// This file is auto-generated by @hey-api/openapi-ts

export const $FrontRenewTokenRequestDto = {
    type: 'object',
    properties: {
        hostname: {
            type: 'string',
            example: 'luckyblock.mbg.local'
        }
    },
    required: ['hostname']
} as const;

export const $CookieDto = {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        value: {
            type: 'string'
        },
        path: {
            type: 'string'
        },
        domain: {
            type: 'string'
        },
        expires: {
            type: 'number'
        },
        sameSite: {
            type: 'string'
        },
        httpOnly: {
            type: 'boolean'
        }
    },
    required: ['name', 'value', 'path', 'domain', 'expires', 'sameSite', 'httpOnly']
} as const;

export const $FrontLoginResponseDto = {
    type: 'object',
    properties: {
        jwt: {
            '$ref': '#/components/schemas/CookieDto'
        },
        refreshToken: {
            '$ref': '#/components/schemas/CookieDto'
        },
        tokenRenewUrl: {
            '$ref': '#/components/schemas/CookieDto'
        }
    },
    required: ['jwt', 'refreshToken', 'tokenRenewUrl']
} as const;

export const $FrontLoginRequestDto = {
    type: 'object',
    properties: {
        hostname: {
            type: 'string',
            example: 'luckyblock.mbg.local'
        },
        username: {
            type: 'string'
        },
        password: {
            type: 'string'
        },
        referralCode: {
            type: 'string',
            default: null
        },
        cfToken: {
            type: 'string'
        },
        clientIp: {
            type: 'string'
        },
        clientCountry: {
            type: 'string'
        }
    },
    required: ['hostname', 'username', 'password', 'clientIp', 'clientCountry']
} as const;

export const $ServerErrorResponseDto = {
    type: 'object',
    properties: {
        message: {
            type: 'string'
        },
        error: {
            type: 'string'
        },
        statusCode: {
            type: 'number'
        }
    },
    required: ['message', 'error', 'statusCode']
} as const;

export const $FrontTelegramLoginRequestDto = {
    type: 'object',
    properties: {
        hostname: {
            type: 'string',
            example: 'luckyblock.mbg.local'
        },
        id: {
            type: 'number'
        },
        first_name: {
            type: 'string',
            default: null
        },
        last_name: {
            type: 'string',
            default: null
        },
        username: {
            type: 'string',
            default: null
        },
        photo_url: {
            type: 'string',
            default: null
        },
        auth_date: {
            type: 'number'
        },
        hash: {
            type: 'string'
        },
        referralCode: {
            type: 'string',
            default: null
        },
        clientIp: {
            type: 'string'
        },
        clientCountry: {
            type: 'string'
        }
    },
    required: ['hostname', 'id', 'auth_date', 'hash', 'clientIp', 'clientCountry']
} as const;

export const $ValidationConstraintDto = {
    type: 'object',
    properties: {
        type: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['type', 'message']
} as const;

export const $ValidationErrorInstanceDto = {
    type: 'object',
    properties: {
        property: {
            type: 'string'
        },
        constraints: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ValidationConstraintDto'
            }
        }
    },
    required: ['property', 'constraints']
} as const;

export const $ValidationErrorResponseDto = {
    type: 'object',
    properties: {
        type: {
            type: 'string',
            default: 'validation-error',
            enum: ['validation-error']
        },
        errors: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ValidationErrorInstanceDto'
            }
        },
        message: {
            type: 'string',
            default: 'validation error'
        },
        statusCode: {
            type: 'number',
            default: 400
        }
    },
    required: ['type', 'errors', 'message', 'statusCode']
} as const;

export const $FrontRegisterRequestDto = {
    type: 'object',
    properties: {
        hostname: {
            type: 'string',
            example: 'luckyblock.mbg.local'
        },
        username: {
            type: 'string'
        },
        password: {
            type: 'string'
        },
        confirmPassword: {
            type: 'string'
        },
        agreedTerms: {
            type: 'boolean'
        },
        referralCode: {
            type: 'string',
            default: null
        },
        cfToken: {
            type: 'string'
        },
        clientIp: {
            type: 'string'
        },
        clientCountry: {
            type: 'string'
        }
    },
    required: ['hostname', 'username', 'password', 'agreedTerms', 'clientIp', 'clientCountry']
} as const;

export const $FrontProfileResponseDto = {
    type: 'object',
    properties: {
        firstName: {
            type: 'string'
        },
        lastName: {
            type: 'string'
        },
        nickName: {
            type: 'string'
        },
        email: {
            type: 'string'
        },
        referralCode: {
            type: 'string'
        },
        walletConnected: {
            type: 'boolean',
            default: false
        }
    },
    required: ['firstName', 'lastName', 'nickName', 'email', 'referralCode', 'walletConnected']
} as const;

export const $FrontMissionResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        type: {
            type: 'string',
            enum: ['register', 'login', 'inviteFriend', 'wager', 'nft', 'token', 'twitterFollow', 'youtubeFollow', 'telegramJoin', 'discordJoin', 'stakeTokens']
        },
        isRecurring: {
            type: 'boolean'
        },
        theme: {
            type: 'string',
            enum: ['gold', 'silver', 'bronze']
        },
        badgeLabel: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        link: {
            type: 'string'
        },
        linkTheme: {
            type: 'string'
        },
        linkLabel: {
            type: 'string'
        },
        tooltip: {
            type: 'string'
        },
        imageSrc: {
            type: 'string'
        },
        ends: {
            type: 'string'
        }
    },
    required: ['id', 'type', 'isRecurring', 'theme', 'badgeLabel', 'title', 'description', 'link', 'linkTheme', 'linkLabel', 'tooltip', 'imageSrc', 'ends']
} as const;

export const $FrontMissionStatsDto = {
    type: 'object',
    properties: {
        progress: {
            type: 'number',
            default: null
        },
        progressLabel: {
            type: 'string',
            default: null
        },
        isCompleted: {
            type: 'boolean'
        },
        repetition: {
            type: 'number',
            default: null
        }
    },
    required: ['progress', 'progressLabel', 'isCompleted', 'repetition']
} as const;

export const $FrontUserMissionResponseDto = {
    type: 'object',
    properties: {
        missions: {
            type: 'object',
            additionalProperties: {
                '$ref': '#/components/schemas/FrontMissionStatsDto'
            }
        }
    },
    required: ['missions']
} as const;

export const $FrontMissionV2MissionRewardDto = {
    type: 'object',
    properties: {
        imageUrl: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        amount: {
            type: 'number'
        },
        worth: {
            type: 'number'
        }
    },
    required: ['imageUrl', 'label', 'amount', 'worth']
} as const;

export const $FrontMissionV2MissionResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        type: {
            type: 'string',
            enum: ['register', 'login', 'inviteFriend', 'wager', 'nft', 'token', 'twitterFollow', 'youtubeFollow', 'telegramJoin', 'discordJoin', 'stakeTokens']
        },
        progress: {
            type: 'number',
            nullable: true
        },
        progressLabel: {
            type: 'string',
            nullable: true
        },
        completed: {
            type: 'boolean'
        },
        repetition: {
            type: 'number',
            nullable: true
        },
        recurring: {
            type: 'boolean'
        },
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        tooltip: {
            type: 'string'
        },
        badgeLabel: {
            type: 'string'
        },
        theme: {
            type: 'string',
            enum: ['gold', 'silver', 'bronze']
        },
        buttonLink: {
            type: 'string'
        },
        buttonTheme: {
            type: 'string'
        },
        buttonLabel: {
            type: 'string'
        },
        ends: {
            type: 'string',
            nullable: true
        },
        nextStarts: {
            type: 'string',
            nullable: true
        },
        image: {
            type: 'string'
        },
        backgroundImage: {
            type: 'string'
        },
        reward: {
            '$ref': '#/components/schemas/FrontMissionV2MissionRewardDto'
        }
    },
    required: ['id', 'type', 'progress', 'progressLabel', 'completed', 'repetition', 'recurring', 'title', 'description', 'tooltip', 'badgeLabel', 'theme', 'buttonLink', 'buttonTheme', 'buttonLabel', 'ends', 'nextStarts', 'image', 'backgroundImage', 'reward']
} as const;

export const $FrontMissionV2UserStatsResponseDto = {
    type: 'object',
    properties: {
        totalMissions: {
            type: 'number'
        },
        completedMissions: {
            type: 'number'
        }
    },
    required: ['totalMissions', 'completedMissions']
} as const;

export const $FrontMissionV2ResponseDto = {
    type: 'object',
    properties: {
        missions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontMissionV2MissionResponseDto'
            }
        },
        userStats: {
            '$ref': '#/components/schemas/FrontMissionV2UserStatsResponseDto'
        }
    },
    required: ['missions', 'userStats']
} as const;

export const $FrontBrandHostV2ResponseDto = {
    type: 'object',
    properties: {
        hostname: {
            type: 'string'
        },
        cookieDomain: {
            type: 'string'
        }
    },
    required: ['hostname', 'cookieDomain']
} as const;

export const $FrontBrandResponseDto = {
    type: 'object',
    properties: {
        label: {
            type: 'string'
        },
        baseTicketId: {
            type: 'string'
        },
        host: {
            '$ref': '#/components/schemas/FrontBrandHostV2ResponseDto'
        }
    },
    required: ['label', 'baseTicketId', 'host']
} as const;

export const $FrontImage = {
    type: 'object',
    properties: {
        alt: {
            type: 'string'
        },
        src: {
            type: 'string'
        },
        width: {
            type: 'number'
        },
        height: {
            type: 'number'
        }
    },
    required: ['alt', 'src', 'width', 'height']
} as const;

export const $FrontLink = {
    type: 'object',
    properties: {
        href: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        openInNewTab: {
            type: 'boolean'
        }
    },
    required: ['href', 'label', 'openInNewTab']
} as const;

export const $FrontBrandConfigurationHeaderV2ResponseDto = {
    type: 'object',
    properties: {
        siteName: {
            type: 'string'
        },
        logoMobile: {
            '$ref': '#/components/schemas/FrontImage'
        },
        logoDesktop: {
            '$ref': '#/components/schemas/FrontImage'
        },
        linksAuthenticated: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontLink'
            }
        },
        linksGuest: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontLink'
            }
        }
    },
    required: ['siteName', 'logoMobile', 'logoDesktop', 'linksAuthenticated', 'linksGuest']
} as const;

export const $FrontBrandConfigurationFooterV2ResponseDto = {
    type: 'object',
    properties: {
        copyright: {
            type: 'string'
        },
        disclaimer: {
            type: 'string'
        },
        linksAuthenticatedLeft: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontLink'
            }
        },
        linksAuthenticatedRight: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontLink'
            }
        },
        linksGuestLeft: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontLink'
            }
        },
        linksGuestRight: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontLink'
            }
        },
        logo: {
            '$ref': '#/components/schemas/FrontImage'
        }
    },
    required: ['copyright', 'disclaimer', 'linksAuthenticatedLeft', 'linksAuthenticatedRight', 'linksGuestLeft', 'linksGuestRight', 'logo']
} as const;

export const $FrontBrandConfigurationV2ResponseDto = {
    type: 'object',
    properties: {
        header: {
            '$ref': '#/components/schemas/FrontBrandConfigurationHeaderV2ResponseDto'
        },
        footer: {
            '$ref': '#/components/schemas/FrontBrandConfigurationFooterV2ResponseDto'
        }
    },
    required: ['header', 'footer']
} as const;

export const $FrontBrandEnvironmentV2ResponseDto = {
    type: 'object',
    properties: {
        theme: {
            type: 'string',
            enum: ['lucky-block', 'prc-jackpot', 'free-btc']
        },
        telegramBotUsername: {
            type: 'string'
        },
        telegramLink: {
            type: 'string'
        },
        referralLink: {
            type: 'string'
        },
        turnstileSiteKey: {
            type: 'string'
        },
        turnstileApiUrl: {
            type: 'string'
        },
        isTurnstileEnabled: {
            type: 'boolean'
        },
        gtmId: {
            type: 'string'
        },
        reownProjectId: {
            type: 'string'
        },
        reownProjectName: {
            type: 'string'
        },
        reownProjectDescription: {
            type: 'string'
        },
        reownProjectUrl: {
            type: 'string'
        }
    },
    required: ['theme', 'telegramBotUsername', 'telegramLink', 'referralLink', 'turnstileSiteKey', 'turnstileApiUrl', 'isTurnstileEnabled', 'gtmId', 'reownProjectId', 'reownProjectName', 'reownProjectDescription', 'reownProjectUrl']
} as const;

export const $FrontBrandV2ResponseDto = {
    type: 'object',
    properties: {
        label: {
            type: 'string'
        },
        baseTicketId: {
            type: 'string'
        },
        host: {
            '$ref': '#/components/schemas/FrontBrandHostV2ResponseDto'
        },
        configuration: {
            '$ref': '#/components/schemas/FrontBrandConfigurationV2ResponseDto'
        },
        environment: {
            '$ref': '#/components/schemas/FrontBrandEnvironmentV2ResponseDto'
        }
    },
    required: ['label', 'baseTicketId', 'host', 'configuration', 'environment']
} as const;

export const $FrontJackpotsResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        ticketId: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        link: {
            type: 'string'
        },
        prizeDescription: {
            type: 'string'
        },
        tooltip: {
            type: 'string'
        },
        imageSrc: {
            type: 'string'
        },
        jackpotTheme: {
            type: 'string'
        },
        heroImageSrc: {
            type: 'string'
        },
        ticketLabel: {
            type: 'string'
        },
        ticketImageSrc: {
            type: 'string'
        },
        ends: {
            type: 'string'
        },
        starts: {
            type: 'string'
        },
        totalTickets: {
            type: 'number'
        },
        totalUsers: {
            type: 'number'
        },
        userRank: {
            type: 'number'
        }
    },
    required: ['id', 'ticketId', 'label', 'link', 'prizeDescription', 'tooltip', 'imageSrc', 'jackpotTheme', 'heroImageSrc', 'ticketLabel', 'ticketImageSrc', 'ends', 'starts', 'totalTickets', 'totalUsers', 'userRank']
} as const;

export const $FrontJackpotStatsTicketResponseDto = {
    type: 'object',
    properties: {
        label: {
            type: 'string'
        },
        tooltip: {
            type: 'string'
        },
        imageSrc: {
            type: 'string'
        }
    },
    required: ['label', 'tooltip', 'imageSrc']
} as const;

export const $FrontJackpotStatsResponseDto = {
    type: 'object',
    properties: {
        ticket: {
            '$ref': '#/components/schemas/FrontJackpotStatsTicketResponseDto'
        },
        userTickets: {
            type: 'number',
            default: null
        },
        userPosition: {
            type: 'number',
            default: null
        },
        userChance: {
            type: 'number',
            default: null
        },
        totalTickets: {
            type: 'number'
        },
        totalUsers: {
            type: 'number'
        }
    },
    required: ['ticket', 'userTickets', 'userPosition', 'userChance', 'totalTickets', 'totalUsers']
} as const;

export const $FrontJackpotResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        ticketId: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        prizeDescription: {
            type: 'string'
        },
        tooltip: {
            type: 'string'
        },
        title: {
            type: 'string',
            default: null
        },
        description: {
            type: 'string',
            default: null
        },
        heroImageSrc: {
            type: 'string',
            default: null
        },
        imageSrc: {
            type: 'string'
        },
        starts: {
            type: 'string'
        },
        ends: {
            type: 'string'
        },
        playerCount: {
            type: 'number'
        }
    },
    required: ['id', 'ticketId', 'label', 'prizeDescription', 'tooltip', 'title', 'description', 'heroImageSrc', 'imageSrc', 'starts', 'ends', 'playerCount']
} as const;

export const $FrontJackpotTestimonialsTestimonialResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        imageUrl: {
            type: 'string'
        },
        quote: {
            type: 'string'
        }
    },
    required: ['id', 'name', 'imageUrl', 'quote']
} as const;

export const $FrontJackpotTestimonialsResponseDto = {
    type: 'object',
    properties: {
        illustrationImage: {
            type: 'string'
        },
        testimonials: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontJackpotTestimonialsTestimonialResponseDto'
            }
        }
    },
    required: ['illustrationImage', 'testimonials']
} as const;

export const $FrontJackpotWinnersWinnerResponseDto = {
    type: 'object',
    properties: {
        nameShort: {
            type: 'string'
        },
        prize: {
            type: 'string'
        },
        ticketImage: {
            type: 'string'
        },
        ticketAmount: {
            type: 'number'
        },
        isCurrentUser: {
            type: 'boolean'
        },
        chance: {
            type: 'number'
        },
        date: {
            type: 'string'
        }
    },
    required: ['nameShort', 'prize', 'ticketImage', 'ticketAmount', 'isCurrentUser', 'chance', 'date']
} as const;

export const $FrontJackpotWinnersV2ResponseDto = {
    type: 'object',
    properties: {
        illustrationImage: {
            type: 'string'
        },
        winners: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontJackpotWinnersWinnerResponseDto'
            }
        }
    },
    required: ['illustrationImage', 'winners']
} as const;

export const $FrontLocaleResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        localeCode: {
            type: 'string'
        },
        languageCode: {
            type: 'string'
        },
        countryCode: {
            type: 'string'
        }
    },
    required: ['id', 'localeCode', 'languageCode', 'countryCode']
} as const;

export const $FrontTicketPurchaseTagResponseDto = {
    type: 'object',
    properties: {
        intent: {
            type: 'string',
            enum: ['success', 'danger']
        },
        label: {
            type: 'string'
        }
    },
    required: ['intent', 'label']
} as const;

export const $FrontTicketPurchaseOfferStatsResponseDto = {
    type: 'object',
    properties: {
        numberOfSales: {
            type: 'number'
        },
        soldTickets: {
            type: 'number'
        }
    },
    required: ['numberOfSales', 'soldTickets']
} as const;

export const $FrontTicketPurchaseOfferResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        highlight: {
            type: 'string',
            default: null
        },
        isDefaultOffer: {
            type: 'boolean'
        },
        pricingModel: {
            type: 'string',
            enum: ['fixed', 'percentage']
        },
        minimumAmount: {
            type: 'number'
        },
        price: {
            type: 'string'
        },
        discountPercentage: {
            type: 'string'
        },
        discount: {
            type: 'string',
            default: null
        },
        tag: {
            default: null,
            allOf: [
                {
                    '$ref': '#/components/schemas/FrontTicketPurchaseTagResponseDto'
                }
            ]
        },
        label: {
            type: 'string'
        },
        offerBackgroundImage: {
            type: 'string'
        },
        ends: {
            format: 'date-time',
            type: 'string'
        },
        starts: {
            format: 'date-time',
            type: 'string'
        },
        buttonLabel: {
            type: 'string'
        },
        buttonTheme: {
            type: 'string',
            enum: ['default', 'primary', 'telegram', 'discrete', 'link']
        },
        footerText: {
            type: 'string'
        },
        stats: {
            '$ref': '#/components/schemas/FrontTicketPurchaseOfferStatsResponseDto'
        }
    },
    required: ['id', 'highlight', 'isDefaultOffer', 'pricingModel', 'minimumAmount', 'price', 'discountPercentage', 'discount', 'tag', 'label', 'offerBackgroundImage', 'ends', 'starts', 'buttonLabel', 'buttonTheme', 'footerText', 'stats']
} as const;

export const $FrontTicketPurchaseTicketStatsResponseDto = {
    type: 'object',
    properties: {
        numberOfSales: {
            type: 'number'
        },
        soldTickets: {
            type: 'number'
        }
    },
    required: ['numberOfSales', 'soldTickets']
} as const;

export const $FrontTicketPurchaseResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        theme: {
            type: 'string',
            enum: ['gold', 'silver', 'bronze']
        },
        image: {
            type: 'string'
        },
        backgroundImage: {
            type: 'string'
        },
        illustrationImage: {
            type: 'string'
        },
        offers: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontTicketPurchaseOfferResponseDto'
            }
        },
        stats: {
            '$ref': '#/components/schemas/FrontTicketPurchaseTicketStatsResponseDto'
        }
    },
    required: ['id', 'label', 'theme', 'image', 'backgroundImage', 'illustrationImage', 'offers', 'stats']
} as const;

export const $FrontTicketStatsResponseDto = {
    type: 'object',
    properties: {
        ticketId: {
            type: 'string'
        },
        poolSize: {
            type: 'number'
        }
    },
    required: ['ticketId', 'poolSize']
} as const;

export const $FrontJackpotWinnersResponseDto = {
    type: 'object',
    properties: {
        nameShort: {
            type: 'string'
        },
        drawDate: {
            type: 'string'
        },
        poolNumber: {
            type: 'number'
        },
        numberOfTickets: {
            type: 'number'
        },
        winChance: {
            type: 'number'
        },
        prizes: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        isCurrentUser: {
            type: 'boolean',
            default: false
        }
    },
    required: ['nameShort', 'drawDate', 'poolNumber', 'numberOfTickets', 'winChance', 'prizes', 'isCurrentUser']
} as const;

export const $FrontLeaderboardRowResponseDto = {
    type: 'object',
    properties: {
        rank: {
            type: 'number'
        },
        ticketAmount: {
            type: 'number'
        },
        nameShort: {
            type: 'string'
        },
        chance: {
            type: 'string'
        },
        isCurrentUser: {
            type: 'boolean',
            default: false
        }
    },
    required: ['rank', 'ticketAmount', 'nameShort', 'chance', 'isCurrentUser']
} as const;

export const $FrontLeaderboardResponseDto = {
    type: 'object',
    properties: {
        leaderboard: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontLeaderboardRowResponseDto'
            }
        },
        currentUser: {
            default: null,
            allOf: [
                {
                    '$ref': '#/components/schemas/FrontLeaderboardRowResponseDto'
                }
            ]
        }
    },
    required: ['leaderboard', 'currentUser']
} as const;

export const $FrontLeaderboardV2JackpotTicketResponseDto = {
    type: 'object',
    properties: {
        label: {
            type: 'string'
        }
    },
    required: ['label']
} as const;

export const $FrontLeaderboardRowV2ResponseDto = {
    type: 'object',
    properties: {
        rank: {
            type: 'number'
        },
        ticketAmount: {
            type: 'number'
        },
        nameShort: {
            type: 'string'
        },
        chance: {
            type: 'number'
        },
        isCurrentUser: {
            type: 'boolean',
            default: false
        }
    },
    required: ['rank', 'ticketAmount', 'nameShort', 'chance', 'isCurrentUser']
} as const;

export const $FrontLeaderboardV2JackpotResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        ticket: {
            '$ref': '#/components/schemas/FrontLeaderboardV2JackpotTicketResponseDto'
        },
        rows: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontLeaderboardRowV2ResponseDto'
            }
        },
        userRow: {
            '$ref': '#/components/schemas/FrontLeaderboardRowV2ResponseDto'
        }
    },
    required: ['id', 'label', 'ticket', 'rows', 'userRow']
} as const;

export const $FrontLeaderboardV2ResponseDto = {
    type: 'object',
    properties: {
        jackpots: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontLeaderboardV2JackpotResponseDto'
            }
        }
    },
    required: ['jackpots']
} as const;

export const $FrontWalletConnectRequestDto = {
    type: 'object',
    properties: {
        address: {
            type: 'string'
        }
    },
    required: ['address']
} as const;

export const $FrontWalletConnectResponseDto = {
    type: 'object',
    properties: {
        address: {
            type: 'string'
        },
        nonce: {
            type: 'string'
        }
    },
    required: ['address', 'nonce']
} as const;

export const $FrontWalletVerifyRequestDto = {
    type: 'object',
    properties: {
        hostname: {
            type: 'string',
            example: 'luckyblock.mbg.local'
        },
        address: {
            type: 'string'
        },
        signature: {
            type: 'string'
        }
    },
    required: ['hostname', 'address', 'signature']
} as const;

export const $FrontWalletVerifyResponseDto = {
    type: 'object',
    properties: {
        ok: {
            type: 'boolean'
        },
        message: {
            type: 'string',
            default: null
        }
    },
    required: ['ok', 'message']
} as const;

export const $FrontCurrencyRateResponseDto = {
    type: 'object',
    properties: {
        source: {
            type: 'string'
        },
        target: {
            type: 'string'
        },
        rate: {
            type: 'string'
        }
    },
    required: ['source', 'target', 'rate']
} as const;

export const $FrontUserTicketBalanceResponseDto = {
    type: 'object',
    properties: {
        ticketId: {
            type: 'string'
        },
        ticketAmount: {
            type: 'number'
        }
    },
    required: ['ticketId', 'ticketAmount']
} as const;

export const $FrontUserTicketsBalanceResponseDto = {
    type: 'object',
    properties: {
        balance: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontUserTicketBalanceResponseDto'
            }
        }
    },
    required: ['balance']
} as const;

export const $FrontUserTicketV2ResponseDto = {
    type: 'object',
    properties: {
        label: {
            type: 'string'
        },
        tooltip: {
            type: 'string'
        },
        imageSrc: {
            type: 'string'
        }
    },
    required: ['label', 'tooltip', 'imageSrc']
} as const;

export const $FrontUserTicketBalanceV2ResponseDto = {
    type: 'object',
    properties: {
        ticketId: {
            type: 'string'
        },
        ticket: {
            '$ref': '#/components/schemas/FrontUserTicketV2ResponseDto'
        },
        ticketAmount: {
            type: 'number'
        }
    },
    required: ['ticketId', 'ticket', 'ticketAmount']
} as const;

export const $FrontUserTicketsBalanceV2ResponseDto = {
    type: 'object',
    properties: {
        balances: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontUserTicketBalanceV2ResponseDto'
            }
        }
    },
    required: ['balances']
} as const;

export const $FrontUserBalanceResponseDto = {
    type: 'object',
    properties: {
        label: {
            type: 'string'
        },
        icon: {
            type: 'string'
        },
        currencyCode: {
            type: 'string'
        },
        balance: {
            type: 'number'
        }
    },
    required: ['label', 'currencyCode', 'balance']
} as const;

export const $FrontUserUpdateCurrencyRequestDto = {
    type: 'object',
    properties: {
        currency: {
            type: 'string'
        }
    },
    required: ['currency']
} as const;

export const $FrontUserUpdateCurrencyResponseDto = {
    type: 'object',
    properties: {
        success: {
            type: 'boolean'
        }
    },
    required: ['success']
} as const;

export const $FrontUserReferralStatsResponseDto = {
    type: 'object',
    properties: {
        timeframe: {
            type: 'string',
            enum: ['currentMonth', 'previousMonth', 'allTime']
        },
        count: {
            type: 'number'
        },
        amount: {
            type: 'string'
        }
    },
    required: ['timeframe', 'count', 'amount']
} as const;

export const $PageMetaOpenGraphImageDto = {
    type: 'object',
    properties: {
        url: {
            type: 'string'
        },
        alt: {
            type: 'string'
        },
        width: {
            type: 'object'
        },
        height: {
            type: 'object'
        }
    },
    required: ['url']
} as const;

export const $PageMetaOpenGraphDto = {
    type: 'object',
    properties: {
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        siteName: {
            type: 'string'
        },
        locale: {
            type: 'string'
        },
        type: {
            type: 'string',
            enum: ['website', 'article']
        },
        url: {
            type: 'string'
        },
        images: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/PageMetaOpenGraphImageDto'
            }
        }
    },
    required: ['title', 'description', 'siteName', 'locale', 'type', 'url', 'images']
} as const;

export const $PageMetaTwitterImageDto = {
    type: 'object',
    properties: {
        url: {
            type: 'string'
        },
        alt: {
            type: 'string'
        },
        width: {
            type: 'object'
        },
        height: {
            type: 'object'
        }
    },
    required: ['url']
} as const;

export const $PageMetaTwitterDto = {
    type: 'object',
    properties: {
        card: {
            type: 'string',
            enum: ['summary', 'summary_large_image', 'app']
        },
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        images: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/PageMetaTwitterImageDto'
            }
        }
    },
    required: ['card', 'title', 'description', 'images']
} as const;

export const $PageMetaRobotsDto = {
    type: 'object',
    properties: {
        index: {
            type: 'boolean',
            default: false
        },
        follow: {
            type: 'boolean',
            default: false
        }
    },
    required: ['index', 'follow']
} as const;

export const $PageMetaDto = {
    type: 'object',
    properties: {
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        canonical: {
            type: 'string'
        },
        openGraph: {
            '$ref': '#/components/schemas/PageMetaOpenGraphDto'
        },
        twitter: {
            '$ref': '#/components/schemas/PageMetaTwitterDto'
        },
        links: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        robots: {
            '$ref': '#/components/schemas/PageMetaRobotsDto'
        }
    },
    required: ['title', 'description', 'canonical', 'openGraph', 'twitter', 'links', 'robots']
} as const;

export const $FrontCmsPageResponseDto = {
    type: 'object',
    properties: {
        meta: {
            '$ref': '#/components/schemas/PageMetaDto'
        },
        content: {
            type: 'string'
        },
        contentBox: {
            type: 'string'
        }
    },
    required: ['meta', 'content', 'contentBox']
} as const;

export const $FrontFaqItemDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        question: {
            type: 'string'
        },
        answer: {
            type: 'string'
        }
    },
    required: ['id', 'question', 'answer']
} as const;

export const $FrontFaqDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        items: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontFaqItemDto'
            }
        }
    },
    required: ['id', 'label', 'description', 'items']
} as const;

export const $FrontFaqResponseDto = {
    type: 'object',
    properties: {
        faqs: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontFaqDto'
            }
        }
    },
    required: ['faqs']
} as const;

export const $FrontSinglePurchaseRequestDto = {
    type: 'object',
    properties: {
        hostname: {
            type: 'string',
            example: 'luckyblock.mbg.local'
        },
        language: {
            type: 'string',
            example: 'en'
        },
        offerId: {
            type: 'string',
            example: '96e3505d-04cc-4597-a840-d2cf9cac9d9b'
        },
        currency: {
            type: 'string',
            example: 'BTC'
        },
        ticketAmount: {
            type: 'number',
            minimum: 1,
            maximum: 100000000000,
            example: 1
        }
    },
    required: ['hostname', 'language', 'offerId', 'currency', 'ticketAmount']
} as const;

export const $FrontSinglePurchaseResponseResultDto = {
    type: 'object',
    properties: {
        purchaseId: {
            type: 'string'
        },
        ticketAmount: {
            type: 'number'
        },
        clientCurrency: {
            type: 'string'
        },
        exchangeRate: {
            type: 'number'
        },
        orderTotalInOfferCurrency: {
            type: 'number'
        },
        orderTotalInClientCurrency: {
            type: 'number'
        },
        status: {
            type: 'string',
            enum: ['pending', 'fulfilling', 'complete', 'failed']
        },
        identityId: {
            type: 'string'
        }
    },
    required: ['purchaseId', 'ticketAmount', 'clientCurrency', 'exchangeRate', 'orderTotalInOfferCurrency', 'orderTotalInClientCurrency', 'status', 'identityId']
} as const;

export const $FrontSinglePurchaseResponseDto = {
    type: 'object',
    properties: {
        result: {
            default: null,
            allOf: [
                {
                    '$ref': '#/components/schemas/FrontSinglePurchaseResponseResultDto'
                }
            ]
        },
        errorMessage: {
            type: 'string',
            nullable: true,
            default: null
        }
    },
    required: ['result', 'errorMessage']
} as const;

export const $FrontSinglePurchaseStatusResponseDto = {
    type: 'object',
    properties: {
        transactionId: {
            type: 'string'
        },
        status: {
            type: 'string',
            enum: ['pending', 'fulfilling', 'complete', 'failed']
        },
        errorTitle: {
            type: 'string'
        },
        errorDescription: {
            type: 'string'
        }
    },
    required: ['transactionId', 'status', 'errorTitle', 'errorDescription']
} as const;

export const $FrontJackpotPlatformStatsResponseDto = {
    type: 'object',
    properties: {
        numberOfUsers: {
            type: 'number'
        },
        numberOfUsersVelocity: {
            type: 'string'
        },
        numberOfGames: {
            type: 'number'
        },
        numberOfGamesVelocity: {
            type: 'string'
        },
        amountOfWinnings: {
            type: 'string'
        },
        amountOfWinningsVelocity: {
            type: 'string'
        }
    },
    required: ['numberOfUsers', 'numberOfUsersVelocity', 'numberOfGames', 'numberOfGamesVelocity', 'amountOfWinnings', 'amountOfWinningsVelocity']
} as const;

export const $FrontWinnersV1WinnerDto = {
    type: 'object',
    properties: {
        chance: {
            type: 'number'
        },
        ticketAmount: {
            type: 'number'
        },
        date: {
            format: 'date-time',
            type: 'string'
        },
        nameShort: {
            type: 'string'
        },
        isCurrentUser: {
            type: 'boolean'
        },
        prize: {
            type: 'string'
        },
        ticketImage: {
            type: 'string'
        }
    },
    required: ['chance', 'ticketAmount', 'date', 'nameShort', 'isCurrentUser', 'prize', 'ticketImage']
} as const;

export const $FrontWinnersV1ResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        winners: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FrontWinnersV1WinnerDto'
            }
        }
    },
    required: ['id', 'label', 'winners']
} as const;

export const $AdminBrandHostResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        hostname: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        },
        cookieDomain: {
            type: 'string'
        }
    },
    required: ['id', 'hostname', 'createdAt', 'updatedAt', 'cookieDomain']
} as const;

export const $AdminBrandEnvironmentResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        telegramBotUsername: {
            type: 'string'
        },
        referralLink: {
            type: 'string'
        },
        turnstileSiteKey: {
            type: 'string'
        },
        turnstileApiUrl: {
            type: 'string'
        },
        isTurnstileEnabled: {
            type: 'boolean'
        },
        gtmId: {
            type: 'string'
        },
        telegramLink: {
            type: 'string'
        },
        reownProjectId: {
            type: 'string'
        },
        reownProjectName: {
            type: 'string'
        },
        reownProjectDescription: {
            type: 'string'
        },
        reownProjectUrl: {
            type: 'string'
        },
        theme: {
            enum: ['lucky-block', 'prc-jackpot', 'free-btc'],
            type: 'string'
        },
        brandId: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'telegramBotUsername', 'referralLink', 'turnstileSiteKey', 'turnstileApiUrl', 'isTurnstileEnabled', 'gtmId', 'telegramLink', 'reownProjectId', 'reownProjectName', 'reownProjectDescription', 'reownProjectUrl', 'theme', 'brandId', 'createdAt', 'updatedAt']
} as const;

export const $AdminLocaleResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        localeCode: {
            type: 'string'
        },
        languageCode: {
            type: 'string'
        },
        countryCode: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'localeCode', 'languageCode', 'countryCode', 'createdAt', 'updatedAt']
} as const;

export const $AdminCmsImageResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        alt: {
            type: 'string'
        },
        url: {
            type: 'string'
        },
        width: {
            type: 'number'
        },
        height: {
            type: 'number'
        },
        displayOrder: {
            type: 'number'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'alt', 'url', 'width', 'height', 'displayOrder', 'createdAt', 'updatedAt']
} as const;

export const $AdminCmsLinkResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        href: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        openInNewTab: {
            type: 'boolean'
        },
        displayOrder: {
            type: 'number'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'href', 'label', 'openInNewTab', 'displayOrder', 'createdAt', 'updatedAt']
} as const;

export const $AdminCmsLinkListResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        links: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminCmsLinkResponseDto'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'links', 'createdAt', 'updatedAt']
} as const;

export const $AdminBrandConfigurationResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleResponseDto'
        },
        headerSiteName: {
            type: 'string'
        },
        headerLogoMobile: {
            '$ref': '#/components/schemas/AdminCmsImageResponseDto'
        },
        headerLogoDesktop: {
            '$ref': '#/components/schemas/AdminCmsImageResponseDto'
        },
        headerLinksAuthenticated: {
            '$ref': '#/components/schemas/AdminCmsLinkListResponseDto'
        },
        headerLinksGuest: {
            '$ref': '#/components/schemas/AdminCmsLinkListResponseDto'
        },
        footerCopyright: {
            type: 'string'
        },
        footerDisclaimer: {
            type: 'string'
        },
        footerLinksAuthenticatedLeft: {
            '$ref': '#/components/schemas/AdminCmsLinkListResponseDto'
        },
        footerLinksAuthenticatedRight: {
            '$ref': '#/components/schemas/AdminCmsLinkListResponseDto'
        },
        footerLinksGuestLeft: {
            '$ref': '#/components/schemas/AdminCmsLinkListResponseDto'
        },
        footerLinksGuestRight: {
            '$ref': '#/components/schemas/AdminCmsLinkListResponseDto'
        },
        footerLogo: {
            '$ref': '#/components/schemas/AdminCmsImageResponseDto'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'locale', 'headerSiteName', 'headerLogoMobile', 'headerLogoDesktop', 'headerLinksAuthenticated', 'headerLinksGuest', 'footerCopyright', 'footerDisclaimer', 'footerLinksAuthenticatedLeft', 'footerLinksAuthenticatedRight', 'footerLinksGuestLeft', 'footerLinksGuestRight', 'footerLogo', 'createdAt', 'updatedAt']
} as const;

export const $AdminLocaleDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        localeCode: {
            type: 'string'
        },
        languageCode: {
            type: 'string'
        },
        countryCode: {
            type: 'string'
        }
    },
    required: ['id', 'localeCode', 'languageCode', 'countryCode']
} as const;

export const $AdminTicketI18nResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        tooltip: {
            type: 'string'
        },
        imageSrc: {
            type: 'string'
        },
        backgroundImageSrc: {
            type: 'string'
        },
        illustrationImageSrc: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleDto'
        }
    },
    required: ['label', 'tooltip', 'imageSrc', 'backgroundImageSrc', 'illustrationImageSrc', 'createdAt', 'updatedAt', 'locale']
} as const;

export const $AdminTicketResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        },
        i18n: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminTicketI18nResponseDto'
            }
        }
    },
    required: ['id', 'label', 'createdAt', 'updatedAt', 'i18n']
} as const;

export const $AdminBrandTicketResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        displayOrder: {
            type: 'number'
        },
        ticket: {
            '$ref': '#/components/schemas/AdminTicketResponseDto'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'isActive', 'displayOrder', 'ticket', 'createdAt', 'updatedAt']
} as const;

export const $AdminBrandResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        isEnabled: {
            type: 'boolean'
        },
        timezone: {
            type: 'string'
        },
        hosts: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminBrandHostResponseDto'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        },
        baseTicket: {
            type: 'object',
            properties: {
                id: {
                    required: true,
                    type: 'string'
                },
                label: {
                    required: true,
                    type: 'string'
                }
            }
        },
        environment: {
            '$ref': '#/components/schemas/AdminBrandEnvironmentResponseDto'
        },
        configurations: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminBrandConfigurationResponseDto'
            }
        },
        brandTickets: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminBrandTicketResponseDto'
            }
        }
    },
    required: ['id', 'label', 'isEnabled', 'timezone', 'hosts', 'createdAt', 'updatedAt', 'baseTicket', 'environment', 'configurations', 'brandTickets']
} as const;

export const $AdminCreateBrandHostRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        hostname: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        cookieDomain: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        }
    },
    required: ['hostname', 'cookieDomain']
} as const;

export const $AdminCreateBrandRequestDto = {
    type: 'object',
    properties: {
        label: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        isEnabled: {
            type: 'boolean',
            default: false
        },
        timezone: {
            type: 'string',
            maxLength: 50
        },
        hosts: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminCreateBrandHostRequestDto'
            }
        },
        baseTicketId: {
            type: 'string'
        }
    },
    required: ['label', 'isEnabled', 'timezone', 'hosts', 'baseTicketId']
} as const;

export const $AdminUpdateBrandEnvironmentRequestDto = {
    type: 'object',
    properties: {
        telegramBotUsername: {
            type: 'string',
            maxLength: 255
        },
        referralLink: {
            type: 'string',
            maxLength: 255
        },
        turnstileSiteKey: {
            type: 'string',
            maxLength: 255
        },
        turnstileApiUrl: {
            type: 'string',
            maxLength: 255
        },
        isTurnstileEnabled: {
            type: 'boolean'
        },
        gtmId: {
            type: 'string',
            maxLength: 255
        },
        telegramLink: {
            type: 'string',
            maxLength: 255
        },
        reownProjectId: {
            type: 'string',
            maxLength: 255
        },
        reownProjectName: {
            type: 'string',
            maxLength: 255
        },
        reownProjectDescription: {
            type: 'string',
            maxLength: 255
        },
        reownProjectUrl: {
            type: 'string',
            maxLength: 255
        },
        theme: {
            enum: ['lucky-block', 'prc-jackpot', 'free-btc'],
            type: 'string'
        }
    },
    required: ['telegramBotUsername', 'referralLink', 'turnstileSiteKey', 'turnstileApiUrl', 'isTurnstileEnabled', 'gtmId', 'telegramLink', 'reownProjectId', 'reownProjectName', 'reownProjectDescription', 'reownProjectUrl', 'theme']
} as const;

export const $AdminCmsImageRequestDto = {
    type: 'object',
    properties: {
        url: {
            type: 'string'
        },
        alt: {
            type: 'string'
        },
        width: {
            type: 'number'
        },
        height: {
            type: 'number'
        },
        displayOrder: {
            type: 'number'
        }
    },
    required: ['url', 'alt', 'width', 'height', 'displayOrder']
} as const;

export const $AdminCmsLinkRequestDto = {
    type: 'object',
    properties: {
        label: {
            type: 'string'
        },
        href: {
            type: 'string'
        },
        openInNewTab: {
            type: 'boolean'
        },
        displayOrder: {
            type: 'number'
        }
    },
    required: ['label', 'href', 'openInNewTab', 'displayOrder']
} as const;

export const $AdminCmsLinkListRequestDto = {
    type: 'object',
    properties: {
        links: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminCmsLinkRequestDto'
            }
        }
    },
    required: ['links']
} as const;

export const $AdminUpdateBrandConfigurationRequestDto = {
    type: 'object',
    properties: {
        localeId: {
            type: 'string'
        },
        headerSiteName: {
            type: 'string'
        },
        headerLogoMobile: {
            '$ref': '#/components/schemas/AdminCmsImageRequestDto'
        },
        headerLogoDesktop: {
            '$ref': '#/components/schemas/AdminCmsImageRequestDto'
        },
        footerLogo: {
            '$ref': '#/components/schemas/AdminCmsImageRequestDto'
        },
        headerLinksAuthenticated: {
            '$ref': '#/components/schemas/AdminCmsLinkListRequestDto'
        },
        headerLinksGuest: {
            '$ref': '#/components/schemas/AdminCmsLinkListRequestDto'
        },
        footerLinksAuthenticatedLeft: {
            '$ref': '#/components/schemas/AdminCmsLinkListRequestDto'
        },
        footerLinksAuthenticatedRight: {
            '$ref': '#/components/schemas/AdminCmsLinkListRequestDto'
        },
        footerLinksGuestLeft: {
            '$ref': '#/components/schemas/AdminCmsLinkListRequestDto'
        },
        footerLinksGuestRight: {
            '$ref': '#/components/schemas/AdminCmsLinkListRequestDto'
        },
        footerCopyright: {
            type: 'string'
        },
        footerDisclaimer: {
            type: 'string'
        }
    },
    required: ['localeId', 'headerSiteName', 'headerLogoMobile', 'headerLogoDesktop', 'footerLogo', 'headerLinksAuthenticated', 'headerLinksGuest', 'footerLinksAuthenticatedLeft', 'footerLinksAuthenticatedRight', 'footerLinksGuestLeft', 'footerLinksGuestRight', 'footerCopyright', 'footerDisclaimer']
} as const;

export const $AdminUpdateTicketI18nRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        tooltip: {
            type: 'string'
        },
        imageSrc: {
            type: 'string'
        },
        backgroundImageSrc: {
            type: 'string'
        },
        illustrationImageSrc: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleDto'
        }
    },
    required: ['label', 'tooltip', 'imageSrc', 'backgroundImageSrc', 'illustrationImageSrc', 'locale']
} as const;

export const $AdminTicketDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        i18n: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateTicketI18nRequestDto'
            }
        }
    },
    required: ['id', 'label']
} as const;

export const $AdminUpdateBrandTicketRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        displayOrder: {
            type: 'number'
        },
        ticket: {
            '$ref': '#/components/schemas/AdminTicketDto'
        }
    },
    required: ['isActive', 'displayOrder', 'ticket']
} as const;

export const $AdminUpdateBrandRequestDto = {
    type: 'object',
    properties: {
        label: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        isEnabled: {
            type: 'boolean',
            default: false
        },
        timezone: {
            type: 'string',
            maxLength: 50
        },
        hosts: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminCreateBrandHostRequestDto'
            }
        },
        baseTicketId: {
            type: 'string',
            nullable: true
        },
        environment: {
            '$ref': '#/components/schemas/AdminUpdateBrandEnvironmentRequestDto'
        },
        configurations: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateBrandConfigurationRequestDto'
            }
        },
        brandTickets: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateBrandTicketRequestDto'
            }
        }
    },
    required: ['label', 'isEnabled', 'timezone', 'hosts', 'baseTicketId']
} as const;

export const $AdminCreateBrandEnvironmentRequestDto = {
    type: 'object',
    properties: {
        telegramBotUsername: {
            type: 'string'
        },
        referralLink: {
            type: 'string'
        },
        turnstileSiteKey: {
            type: 'string'
        },
        turnstileApiUrl: {
            type: 'string'
        },
        isTurnstileEnabled: {
            type: 'boolean'
        },
        gtmId: {
            type: 'string'
        },
        telegramLink: {
            type: 'string'
        },
        reownProjectId: {
            type: 'string'
        },
        reownProjectName: {
            type: 'string'
        },
        reownProjectDescription: {
            type: 'string'
        },
        reownProjectUrl: {
            type: 'string'
        },
        theme: {
            type: 'string',
            enum: ['lucky-block', 'prc-jackpot', 'free-btc']
        },
        brandId: {
            type: 'string'
        }
    },
    required: ['telegramBotUsername', 'referralLink', 'turnstileSiteKey', 'turnstileApiUrl', 'isTurnstileEnabled', 'gtmId', 'telegramLink', 'reownProjectId', 'reownProjectName', 'reownProjectDescription', 'reownProjectUrl', 'theme', 'brandId']
} as const;

export const $Schedule = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        missionSchedule: {
            '$ref': '#/components/schemas/MissionSchedule'
        },
        from: {
            format: 'date-time',
            type: 'string'
        },
        until: {
            format: 'date-time',
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'missionSchedule', 'from', 'until', 'createdAt', 'updatedAt']
} as const;

export const $MissionSchedule = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        mission: {
            '$ref': '#/components/schemas/Mission'
        },
        schedule: {
            '$ref': '#/components/schemas/Schedule'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'mission', 'schedule', 'createdAt', 'updatedAt']
} as const;

export const $BrandHost = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        hostname: {
            type: 'string'
        },
        cookieDomain: {
            type: 'string'
        },
        brand: {
            '$ref': '#/components/schemas/Brand'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'hostname', 'cookieDomain', 'brand', 'createdAt', 'updatedAt']
} as const;

export const $BrandTicketOfferI18n = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/Locale'
        },
        brandTicketOffer: {
            '$ref': '#/components/schemas/BrandTicketOffer'
        },
        backgroundImageSrc: {
            type: 'string'
        },
        discount: {
            type: 'string'
        },
        highlight: {
            type: 'string'
        },
        tagIntent: {
            type: 'string',
            enum: ['success', 'danger']
        },
        tagLabel: {
            type: 'string'
        },
        buttonLabel: {
            type: 'string'
        },
        buttonTheme: {
            type: 'string',
            enum: ['default', 'primary', 'telegram', 'discrete', 'link']
        },
        footerText: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'label', 'locale', 'brandTicketOffer', 'backgroundImageSrc', 'discount', 'highlight', 'tagIntent', 'tagLabel', 'buttonLabel', 'buttonTheme', 'footerText', 'createdAt', 'updatedAt']
} as const;

export const $SinglePurchaseTicketCountByOffer = {
    type: 'object',
    properties: {
        offer: {
            '$ref': '#/components/schemas/BrandTicketOffer'
        },
        offerId: {
            type: 'string'
        },
        numberOfSoldTickets: {
            type: 'number'
        },
        numberOfSales: {
            type: 'number'
        }
    },
    required: ['offer', 'offerId', 'numberOfSoldTickets', 'numberOfSales']
} as const;

export const $BrandTicketOffer = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        ticket: {
            '$ref': '#/components/schemas/Ticket'
        },
        ticketId: {
            type: 'string'
        },
        brand: {
            '$ref': '#/components/schemas/Brand'
        },
        brandId: {
            type: 'string'
        },
        isDefaultOffer: {
            type: 'boolean'
        },
        currency: {
            type: 'string'
        },
        pricingModel: {
            type: 'string',
            enum: ['fixed', 'percentage']
        },
        minimumAmount: {
            type: 'number'
        },
        price: {
            type: 'string'
        },
        discountPercentage: {
            type: 'string'
        },
        visibleFrom: {
            format: 'date-time',
            type: 'string'
        },
        starts: {
            format: 'date-time',
            type: 'string'
        },
        ends: {
            format: 'date-time',
            type: 'string'
        },
        i18n: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BrandTicketOfferI18n'
            }
        },
        singlePurchaseCountByOffer: {
            '$ref': '#/components/schemas/SinglePurchaseTicketCountByOffer'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'label', 'isActive', 'ticket', 'ticketId', 'brand', 'brandId', 'isDefaultOffer', 'currency', 'pricingModel', 'minimumAmount', 'price', 'discountPercentage', 'visibleFrom', 'starts', 'ends', 'i18n', 'singlePurchaseCountByOffer', 'createdAt', 'updatedAt']
} as const;

export const $SinglePurchase = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        bhgAccountId: {
            type: 'string'
        },
        identity: {
            '$ref': '#/components/schemas/Identity'
        },
        identityId: {
            type: 'string'
        },
        offer: {
            '$ref': '#/components/schemas/BrandTicketOffer'
        },
        offerId: {
            type: 'string'
        },
        offerLabel: {
            type: 'string'
        },
        ticket: {
            '$ref': '#/components/schemas/Ticket'
        },
        ticketId: {
            type: 'string'
        },
        offerPricingModel: {
            type: 'string',
            enum: ['fixed', 'percentage']
        },
        offerMinimumAmount: {
            type: 'number'
        },
        offerPrice: {
            type: 'string'
        },
        offerDiscountPercentage: {
            type: 'string'
        },
        offerCurrency: {
            type: 'string'
        },
        clientCurrency: {
            type: 'string'
        },
        exchangeRate: {
            type: 'string'
        },
        ticketAmount: {
            type: 'number'
        },
        orderTotalInOfferCurrency: {
            type: 'string'
        },
        orderTotalInClientCurrency: {
            type: 'string'
        },
        status: {
            type: 'string',
            enum: ['pending', 'fulfilling', 'complete', 'failed']
        },
        errorTitle: {
            type: 'string'
        },
        errorDescription: {
            type: 'string'
        },
        failureReason: {
            type: 'string'
        },
        clientIp: {
            type: 'string'
        },
        clientIpCountry: {
            type: 'string'
        },
        clientDevice: {
            type: 'string'
        },
        clientOs: {
            type: 'string'
        },
        clientBrowser: {
            type: 'string'
        },
        clientDomain: {
            type: 'string'
        },
        bhgAckId: {
            type: 'string'
        },
        bhgAckStatus: {
            type: 'string',
            enum: ['pending', 'failed', 'sent']
        },
        bhgSessionId: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'bhgAccountId', 'identity', 'identityId', 'offer', 'offerId', 'offerLabel', 'ticket', 'ticketId', 'offerPricingModel', 'offerMinimumAmount', 'offerPrice', 'offerDiscountPercentage', 'offerCurrency', 'clientCurrency', 'exchangeRate', 'ticketAmount', 'orderTotalInOfferCurrency', 'orderTotalInClientCurrency', 'status', 'errorTitle', 'errorDescription', 'failureReason', 'clientIp', 'clientIpCountry', 'clientDevice', 'clientOs', 'clientBrowser', 'clientDomain', 'bhgAckId', 'bhgAckStatus', 'bhgSessionId', 'createdAt', 'updatedAt']
} as const;

export const $LedgerEntry = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        identity: {
            '$ref': '#/components/schemas/Identity'
        },
        identityId: {
            type: 'string'
        },
        pool: {
            '$ref': '#/components/schemas/Pool'
        },
        poolId: {
            type: 'string'
        },
        transactionType: {
            type: 'string',
            enum: ['jackpotDraw', 'missionReward', 'revertMissionReward', 'ticketPurchase', 'ticketConversion', 'bet', 'refund']
        },
        ticketAmount: {
            type: 'number'
        },
        balanceAfterTransaction: {
            type: 'number'
        },
        transactionCounterPart: {
            '$ref': '#/components/schemas/LedgerEntry'
        },
        transactionCounterPartId: {
            type: 'string'
        },
        ticket: {
            '$ref': '#/components/schemas/Ticket'
        },
        ticketId: {
            type: 'string'
        },
        missionTicketReward: {
            '$ref': '#/components/schemas/MissionTicketReward'
        },
        missionTicketRewardId: {
            type: 'string'
        },
        singlePurchase: {
            '$ref': '#/components/schemas/SinglePurchase'
        },
        singlePurchaseId: {
            type: 'string'
        },
        details: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'identity', 'identityId', 'pool', 'poolId', 'transactionType', 'ticketAmount', 'balanceAfterTransaction', 'transactionCounterPart', 'transactionCounterPartId', 'ticket', 'ticketId', 'missionTicketReward', 'missionTicketRewardId', 'singlePurchase', 'singlePurchaseId', 'details', 'createdAt', 'updatedAt']
} as const;

export const $PoolEntry = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        pool: {
            '$ref': '#/components/schemas/Pool'
        },
        drawnEntry: {
            '$ref': '#/components/schemas/DrawnEntry'
        },
        ledgerEntry: {
            '$ref': '#/components/schemas/LedgerEntry'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'pool', 'drawnEntry', 'ledgerEntry', 'createdAt', 'updatedAt']
} as const;

export const $Pool = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        number: {
            type: 'number'
        },
        status: {
            type: 'string',
            enum: ['OPEN', 'CLOSED']
        },
        poolStart: {
            format: 'date-time',
            type: 'string'
        },
        poolEnd: {
            format: 'date-time',
            type: 'string'
        },
        entries: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/PoolEntry'
            }
        },
        ledgerEntries: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/LedgerEntry'
            }
        },
        jackpot: {
            '$ref': '#/components/schemas/Jackpot'
        },
        draw: {
            '$ref': '#/components/schemas/Draw'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'number', 'status', 'poolStart', 'poolEnd', 'entries', 'ledgerEntries', 'jackpot', 'draw', 'createdAt', 'updatedAt']
} as const;

export const $Draw = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        randomSeed: {
            type: 'number'
        },
        selectionAlgorithm: {
            type: 'string'
        },
        algorithmVersion: {
            type: 'number'
        },
        pool: {
            '$ref': '#/components/schemas/Pool'
        },
        poolId: {
            type: 'string'
        },
        drawDate: {
            format: 'date-time',
            type: 'string'
        },
        winners: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DrawnEntry'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'randomSeed', 'selectionAlgorithm', 'algorithmVersion', 'pool', 'poolId', 'drawDate', 'winners', 'createdAt', 'updatedAt']
} as const;

export const $DrawnEntry = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        draw: {
            '$ref': '#/components/schemas/Draw'
        },
        poolEntry: {
            '$ref': '#/components/schemas/PoolEntry'
        },
        identity: {
            '$ref': '#/components/schemas/Identity'
        },
        identityId: {
            type: 'string'
        },
        ticketCount: {
            type: 'number'
        },
        winChance: {
            type: 'number'
        },
        prize: {
            '$ref': '#/components/schemas/JackpotPrize'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'draw', 'poolEntry', 'identity', 'identityId', 'ticketCount', 'winChance', 'prize', 'createdAt', 'updatedAt']
} as const;

export const $JackpotPrize = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        amount: {
            type: 'string'
        },
        currency: {
            type: 'string'
        },
        jackpot: {
            '$ref': '#/components/schemas/Jackpot'
        },
        drawTickets: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DrawnEntry'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'amount', 'currency', 'jackpot', 'drawTickets', 'createdAt', 'updatedAt']
} as const;

export const $JackpotTestimonial = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        jackpot: {
            '$ref': '#/components/schemas/Jackpot'
        },
        quote: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        imageUrl: {
            type: 'string'
        },
        isEnabled: {
            type: 'boolean'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'jackpot', 'quote', 'name', 'imageUrl', 'isEnabled', 'createdAt', 'updatedAt']
} as const;

export const $JackpotAcceptanceConditionParameter = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        key: {
            type: 'string'
        },
        value: {
            type: 'string'
        },
        condition: {
            '$ref': '#/components/schemas/JackpotAcceptanceCondition'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'key', 'value', 'condition', 'createdAt', 'updatedAt']
} as const;

export const $JackpotAcceptanceCondition = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        type: {
            type: 'string',
            enum: ['ticketOwnership', 'nftOwnership', 'missionCompletion', 'missionTypeCompletion']
        },
        jackpot: {
            '$ref': '#/components/schemas/Jackpot'
        },
        parameters: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/JackpotAcceptanceConditionParameter'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'type', 'jackpot', 'parameters', 'createdAt', 'updatedAt']
} as const;

export const $JackpotStats = {
    type: 'object',
    properties: {
        totalTickets: {
            type: 'number'
        },
        totalUsers: {
            type: 'number'
        },
        jackpot: {
            '$ref': '#/components/schemas/Jackpot'
        },
        jackpotId: {
            type: 'string'
        },
        ticket: {
            '$ref': '#/components/schemas/Ticket'
        },
        ticketId: {
            type: 'string'
        }
    },
    required: ['totalTickets', 'totalUsers', 'jackpot', 'jackpotId', 'ticket', 'ticketId']
} as const;

export const $JackpotUserStats = {
    type: 'object',
    properties: {
        identityId: {
            type: 'string'
        },
        ticketAmount: {
            type: 'number'
        },
        rank: {
            type: 'number'
        },
        jackpot: {
            '$ref': '#/components/schemas/Jackpot'
        },
        jackpotId: {
            type: 'string'
        },
        ticket: {
            '$ref': '#/components/schemas/Ticket'
        },
        ticketId: {
            type: 'string'
        }
    },
    required: ['identityId', 'ticketAmount', 'rank', 'jackpot', 'jackpotId', 'ticket', 'ticketId']
} as const;

export const $CmsImage = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        imageList: {
            '$ref': '#/components/schemas/CmsImageList'
        },
        alt: {
            type: 'string'
        },
        url: {
            type: 'string'
        },
        width: {
            type: 'number'
        },
        height: {
            type: 'number'
        },
        displayOrder: {
            type: 'number'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'imageList', 'alt', 'url', 'width', 'height', 'displayOrder', 'createdAt', 'updatedAt']
} as const;

export const $CmsImageList = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        images: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CmsImage'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'images', 'createdAt', 'updatedAt']
} as const;

export const $CmsPage = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        routes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CmsRoute'
            }
        },
        locale: {
            '$ref': '#/components/schemas/Locale'
        },
        localeId: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        isEnabled: {
            type: 'boolean'
        },
        metaTitle: {
            type: 'string'
        },
        metaDescription: {
            type: 'string'
        },
        metaRobotsIndex: {
            type: 'boolean'
        },
        metaRobotsFollow: {
            type: 'boolean'
        },
        metaOpenGraphTitle: {
            type: 'string'
        },
        metaOpenGraphDescription: {
            type: 'string'
        },
        metaOpenGraphSiteName: {
            type: 'string'
        },
        metaOpenGraphType: {
            enum: ['website', 'article'],
            type: 'string'
        },
        metaOpenGraphUrl: {
            type: 'string'
        },
        metaOpenGraphImageList: {
            '$ref': '#/components/schemas/CmsImageList'
        },
        metaTwitterCard: {
            enum: ['summary', 'summary_large_image', 'app'],
            type: 'string'
        },
        metaTwitterTitle: {
            type: 'string'
        },
        metaTwitterImageList: {
            '$ref': '#/components/schemas/CmsImageList'
        },
        metaTwitterDescription: {
            type: 'string'
        },
        contentBox: {
            type: 'string'
        },
        content: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'routes', 'locale', 'localeId', 'label', 'isEnabled', 'metaTitle', 'metaDescription', 'metaRobotsIndex', 'metaRobotsFollow', 'metaOpenGraphTitle', 'metaOpenGraphDescription', 'metaOpenGraphSiteName', 'metaOpenGraphType', 'metaOpenGraphUrl', 'metaOpenGraphImageList', 'metaTwitterCard', 'metaTwitterTitle', 'metaTwitterImageList', 'metaTwitterDescription', 'contentBox', 'content', 'createdAt', 'updatedAt']
} as const;

export const $CmsRoute = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        slug: {
            type: 'string'
        },
        access: {
            enum: ['guest', 'user'],
            type: 'string'
        },
        page: {
            '$ref': '#/components/schemas/CmsPage'
        },
        pageId: {
            type: 'string'
        },
        brand: {
            '$ref': '#/components/schemas/Brand'
        },
        brandId: {
            type: 'string'
        },
        isEnabled: {
            type: 'boolean'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'slug', 'access', 'page', 'pageId', 'brand', 'brandId', 'isEnabled', 'createdAt', 'updatedAt']
} as const;

export const $JackpotI18n = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        tooltip: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        prizeDescription: {
            type: 'string'
        },
        imageSrc: {
            type: 'string'
        },
        heroImageSrc: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/Locale'
        },
        pageRoute: {
            '$ref': '#/components/schemas/CmsRoute'
        },
        jackpot: {
            '$ref': '#/components/schemas/Jackpot'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'label', 'tooltip', 'title', 'description', 'prizeDescription', 'imageSrc', 'heroImageSrc', 'locale', 'pageRoute', 'jackpot', 'createdAt', 'updatedAt']
} as const;

export const $Jackpot = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        baseTicket: {
            '$ref': '#/components/schemas/Ticket'
        },
        baseTicketId: {
            type: 'string'
        },
        theme: {
            type: 'string',
            enum: ['gold', 'silver', 'bronze']
        },
        logicalOperator: {
            type: 'string',
            enum: ['AND', 'OR']
        },
        timezone: {
            type: 'string'
        },
        interval: {
            type: 'string',
            enum: ['once', 'daily', 'weekly', 'monthly', 'quarterly', 'yearly']
        },
        numberOfRepetitions: {
            type: 'number'
        },
        from: {
            format: 'date-time',
            type: 'string'
        },
        until: {
            format: 'date-time',
            type: 'string'
        },
        prizes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/JackpotPrize'
            }
        },
        testimonials: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/JackpotTestimonial'
            }
        },
        jackpotAcceptanceConditions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/JackpotAcceptanceCondition'
            }
        },
        brandJackpots: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BrandJackpot'
            }
        },
        stats: {
            '$ref': '#/components/schemas/JackpotStats'
        },
        userStats: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/JackpotUserStats'
            }
        },
        pools: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Pool'
            }
        },
        i18n: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/JackpotI18n'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'label', 'isActive', 'baseTicket', 'baseTicketId', 'theme', 'logicalOperator', 'timezone', 'interval', 'numberOfRepetitions', 'from', 'until', 'prizes', 'testimonials', 'jackpotAcceptanceConditions', 'brandJackpots', 'stats', 'userStats', 'pools', 'i18n', 'createdAt', 'updatedAt']
} as const;

export const $BrandJackpot = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        jackpot: {
            '$ref': '#/components/schemas/Jackpot'
        },
        brand: {
            '$ref': '#/components/schemas/Brand'
        },
        displayOrder: {
            type: 'number'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'isActive', 'jackpot', 'brand', 'displayOrder', 'createdAt', 'updatedAt']
} as const;

export const $BrandTicket = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        ticket: {
            '$ref': '#/components/schemas/Ticket'
        },
        brand: {
            '$ref': '#/components/schemas/Brand'
        },
        displayOrder: {
            type: 'number'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'isActive', 'ticket', 'brand', 'displayOrder', 'createdAt', 'updatedAt']
} as const;

export const $FaqI18n = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/Locale'
        },
        faq: {
            '$ref': '#/components/schemas/Faq'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'label', 'description', 'locale', 'faq', 'createdAt', 'updatedAt']
} as const;

export const $FaqQa = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        faq: {
            '$ref': '#/components/schemas/Faq'
        },
        label: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        locale: {
            '$ref': '#/components/schemas/Locale'
        },
        question: {
            type: 'string'
        },
        answer: {
            type: 'string'
        },
        displayOrder: {
            type: 'number'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'faq', 'label', 'isActive', 'locale', 'question', 'answer', 'displayOrder', 'createdAt', 'updatedAt']
} as const;

export const $Faq = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        tag: {
            type: 'string'
        },
        i18n: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FaqI18n'
            }
        },
        isActive: {
            type: 'boolean'
        },
        faqBrands: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BrandFaq'
            }
        },
        items: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FaqQa'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'label', 'tag', 'i18n', 'isActive', 'faqBrands', 'items', 'createdAt', 'updatedAt']
} as const;

export const $BrandFaq = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        faq: {
            '$ref': '#/components/schemas/Faq'
        },
        brand: {
            '$ref': '#/components/schemas/Brand'
        },
        displayOrder: {
            type: 'number'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'isActive', 'faq', 'brand', 'displayOrder', 'createdAt', 'updatedAt']
} as const;

export const $IdentityTicketBalance = {
    type: 'object',
    properties: {
        identityId: {
            type: 'string'
        },
        ticketAmount: {
            type: 'number'
        },
        rank: {
            type: 'number'
        },
        identity: {
            '$ref': '#/components/schemas/Identity'
        },
        brand: {
            '$ref': '#/components/schemas/Brand'
        },
        ticket: {
            '$ref': '#/components/schemas/Ticket'
        },
        ticketId: {
            type: 'string'
        }
    },
    required: ['identityId', 'ticketAmount', 'rank', 'identity', 'brand', 'ticket', 'ticketId']
} as const;

export const $BrandEnvironment = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        telegramBotUsername: {
            type: 'string'
        },
        referralLink: {
            type: 'string'
        },
        turnstileSiteKey: {
            type: 'string'
        },
        turnstileApiUrl: {
            type: 'string'
        },
        isTurnstileEnabled: {
            type: 'boolean'
        },
        gtmId: {
            type: 'string'
        },
        telegramLink: {
            type: 'string'
        },
        reownProjectId: {
            type: 'string'
        },
        reownProjectName: {
            type: 'string'
        },
        reownProjectDescription: {
            type: 'string'
        },
        reownProjectUrl: {
            type: 'string'
        },
        theme: {
            type: 'string',
            enum: ['lucky-block', 'prc-jackpot', 'free-btc']
        },
        brand: {
            '$ref': '#/components/schemas/Brand'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'telegramBotUsername', 'referralLink', 'turnstileSiteKey', 'turnstileApiUrl', 'isTurnstileEnabled', 'gtmId', 'telegramLink', 'reownProjectId', 'reownProjectName', 'reownProjectDescription', 'reownProjectUrl', 'theme', 'brand', 'createdAt', 'updatedAt']
} as const;

export const $CmsLink = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        linkList: {
            '$ref': '#/components/schemas/CmsLinkList'
        },
        href: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        openInNewTab: {
            type: 'boolean'
        },
        displayOrder: {
            type: 'number'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'linkList', 'href', 'label', 'openInNewTab', 'displayOrder', 'createdAt', 'updatedAt']
} as const;

export const $CmsLinkList = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        links: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CmsLink'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'links', 'createdAt', 'updatedAt']
} as const;

export const $BrandConfiguration = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/Locale'
        },
        headerSiteName: {
            type: 'string'
        },
        headerLogoMobile: {
            '$ref': '#/components/schemas/CmsImage'
        },
        headerLogoDesktop: {
            '$ref': '#/components/schemas/CmsImage'
        },
        headerLinksAuthenticated: {
            '$ref': '#/components/schemas/CmsLinkList'
        },
        headerLinksGuest: {
            '$ref': '#/components/schemas/CmsLinkList'
        },
        footerCopyright: {
            type: 'string'
        },
        footerDisclaimer: {
            type: 'string'
        },
        footerLinksAuthenticatedLeft: {
            '$ref': '#/components/schemas/CmsLinkList'
        },
        footerLinksGuestLeft: {
            '$ref': '#/components/schemas/CmsLinkList'
        },
        footerLinksAuthenticatedRight: {
            '$ref': '#/components/schemas/CmsLinkList'
        },
        footerLinksGuestRight: {
            '$ref': '#/components/schemas/CmsLinkList'
        },
        footerLogo: {
            '$ref': '#/components/schemas/CmsImage'
        },
        brand: {
            '$ref': '#/components/schemas/Brand'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'locale', 'headerSiteName', 'headerLogoMobile', 'headerLogoDesktop', 'headerLinksAuthenticated', 'headerLinksGuest', 'footerCopyright', 'footerDisclaimer', 'footerLinksAuthenticatedLeft', 'footerLinksGuestLeft', 'footerLinksAuthenticatedRight', 'footerLinksGuestRight', 'footerLogo', 'brand', 'createdAt', 'updatedAt']
} as const;

export const $Namespace = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        ns: {
            type: 'string'
        },
        componentI18ns: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ComponentI18n'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'ns', 'componentI18ns', 'createdAt', 'updatedAt']
} as const;

export const $ComponentI18n = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        brand: {
            '$ref': '#/components/schemas/Brand'
        },
        namespace: {
            '$ref': '#/components/schemas/Namespace'
        },
        locale: {
            '$ref': '#/components/schemas/Locale'
        },
        component: {
            type: 'string'
        },
        key: {
            type: 'string'
        },
        value: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'brand', 'namespace', 'locale', 'component', 'key', 'value', 'createdAt', 'updatedAt']
} as const;

export const $Brand = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        isEnabled: {
            type: 'boolean'
        },
        timezone: {
            type: 'string'
        },
        hosts: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BrandHost'
            }
        },
        identities: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Identity'
            }
        },
        brandJackpots: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BrandJackpot'
            }
        },
        brandTickets: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BrandTicket'
            }
        },
        brandFaqs: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BrandFaq'
            }
        },
        missions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Mission'
            }
        },
        routes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CmsRoute'
            }
        },
        ticketBalance: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/IdentityTicketBalance'
            }
        },
        baseTicket: {
            '$ref': '#/components/schemas/Ticket'
        },
        environment: {
            '$ref': '#/components/schemas/BrandEnvironment'
        },
        configurations: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BrandConfiguration'
            }
        },
        componentI18ns: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ComponentI18n'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'label', 'isEnabled', 'timezone', 'hosts', 'identities', 'brandJackpots', 'brandTickets', 'brandFaqs', 'missions', 'routes', 'ticketBalance', 'baseTicket', 'environment', 'configurations', 'componentI18ns', 'createdAt', 'updatedAt']
} as const;

export const $Credential = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        identity: {
            '$ref': '#/components/schemas/Identity'
        },
        identityId: {
            type: 'string'
        },
        type: {
            type: 'string',
            enum: ['bhg', 'telegram']
        },
        bhgAccountId: {
            type: 'string'
        },
        isPrcAccount: {
            type: 'boolean'
        },
        bhgBrandId: {
            type: 'string'
        },
        telegramId: {
            type: 'string'
        },
        telegramUsername: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'identity', 'identityId', 'type', 'bhgAccountId', 'isPrcAccount', 'bhgBrandId', 'telegramId', 'telegramUsername', 'createdAt', 'updatedAt']
} as const;

export const $Referral = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        identity: {
            '$ref': '#/components/schemas/Identity'
        },
        identityId: {
            type: 'string'
        },
        referredIdentity: {
            '$ref': '#/components/schemas/Identity'
        },
        referredIdentityId: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'identity', 'identityId', 'referredIdentity', 'referredIdentityId', 'createdAt', 'updatedAt']
} as const;

export const $Profile = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        identity: {
            '$ref': '#/components/schemas/Identity'
        },
        identityId: {
            type: 'string'
        },
        fullName: {
            type: 'string'
        },
        firstName: {
            type: 'string'
        },
        middleName: {
            type: 'string'
        },
        lastName: {
            type: 'string'
        },
        nickName: {
            type: 'string'
        },
        email: {
            type: 'string'
        },
        referralCode: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'identity', 'identityId', 'fullName', 'firstName', 'middleName', 'lastName', 'nickName', 'email', 'referralCode', 'createdAt', 'updatedAt']
} as const;

export const $Wallet = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        identity: {
            '$ref': '#/components/schemas/Identity'
        },
        identityId: {
            type: 'string'
        },
        address: {
            type: 'string'
        },
        status: {
            type: 'string',
            enum: ['connected', 'verified', 'invalid']
        },
        nonce: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'identity', 'identityId', 'address', 'status', 'nonce', 'createdAt', 'updatedAt']
} as const;

export const $IdentityWagerMission = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        isCompleted: {
            type: 'boolean'
        },
        mission: {
            '$ref': '#/components/schemas/Mission'
        },
        missionId: {
            type: 'string'
        },
        identity: {
            '$ref': '#/components/schemas/Identity'
        },
        identityId: {
            type: 'string'
        },
        amount: {
            type: 'string'
        },
        start: {
            format: 'date-time',
            type: 'string'
        },
        end: {
            format: 'date-time',
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'isCompleted', 'mission', 'missionId', 'identity', 'identityId', 'amount', 'start', 'end', 'createdAt', 'updatedAt']
} as const;

export const $IdentityWagerDaily = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        identity: {
            '$ref': '#/components/schemas/Identity'
        },
        identityId: {
            type: 'string'
        },
        amount: {
            type: 'string'
        },
        wagerDate: {
            format: 'date-time',
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'identity', 'identityId', 'amount', 'wagerDate', 'createdAt', 'updatedAt']
} as const;

export const $Identity = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        brand: {
            '$ref': '#/components/schemas/Brand'
        },
        brandId: {
            type: 'string'
        },
        credentials: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Credential'
            }
        },
        referrals: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Referral'
            }
        },
        referral: {
            '$ref': '#/components/schemas/Referral'
        },
        ticketBalance: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/IdentityTicketBalance'
            }
        },
        missionCompletions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/MissionCompletion'
            }
        },
        profile: {
            '$ref': '#/components/schemas/Profile'
        },
        wallets: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Wallet'
            }
        },
        ledgerEntries: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/LedgerEntry'
            }
        },
        drawnEntries: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DrawnEntry'
            }
        },
        wagerMissions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/IdentityWagerMission'
            }
        },
        identityWager: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/IdentityWagerDaily'
            }
        },
        isBanned: {
            type: 'boolean'
        },
        isTestAccount: {
            type: 'boolean'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'brand', 'brandId', 'credentials', 'referrals', 'referral', 'ticketBalance', 'missionCompletions', 'profile', 'wallets', 'ledgerEntries', 'drawnEntries', 'wagerMissions', 'identityWager', 'isBanned', 'isTestAccount', 'createdAt', 'updatedAt']
} as const;

export const $MissionCompletion = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        mission: {
            '$ref': '#/components/schemas/Mission'
        },
        missionId: {
            type: 'string'
        },
        identity: {
            '$ref': '#/components/schemas/Identity'
        },
        identityId: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'mission', 'missionId', 'identity', 'identityId', 'createdAt', 'updatedAt']
} as const;

export const $MissionParameter = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        key: {
            enum: ['telegramBotId', 'telegramChatId', 'discordChannelId', 'discordChannelJoinLink', 'twitterAccountId', 'twitterAccountAddress', 'youtubeChannelId', 'youtubeChannelAddress', 'nftCollectionId', 'tokenId', 'balanceMin', 'product', 'wagerAmount', 'gameId', 'gameProvider', 'gameType', 'stakedTokenAddress', 'minStakedAmount'],
            type: 'string'
        },
        value: {
            type: 'string'
        },
        mission: {
            '$ref': '#/components/schemas/Mission'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'key', 'value', 'mission', 'createdAt', 'updatedAt']
} as const;

export const $MissionI18n = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        badgeLabel: {
            type: 'string'
        },
        tooltip: {
            type: 'string'
        },
        imageSrc: {
            type: 'string'
        },
        backgroundImageSrc: {
            type: 'string'
        },
        link: {
            type: 'string'
        },
        linkTheme: {
            type: 'string',
            enum: ['default', 'primary']
        },
        linkLabel: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/Locale'
        },
        mission: {
            '$ref': '#/components/schemas/Mission'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'title', 'description', 'badgeLabel', 'tooltip', 'imageSrc', 'backgroundImageSrc', 'link', 'linkTheme', 'linkLabel', 'locale', 'mission', 'createdAt', 'updatedAt']
} as const;

export const $Mission = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        type: {
            type: 'string',
            enum: ['register', 'login', 'inviteFriend', 'wager', 'nft', 'token', 'twitterFollow', 'youtubeFollow', 'telegramJoin', 'discordJoin', 'stakeTokens']
        },
        theme: {
            type: 'string',
            enum: ['gold', 'silver', 'bronze']
        },
        interval: {
            type: 'string',
            enum: ['always', 'once', 'hourly', 'daily', 'weekly', 'monthly', 'quarterly', 'yearly']
        },
        numberOfRepetitions: {
            type: 'number'
        },
        label: {
            type: 'string'
        },
        displayOrder: {
            type: 'number'
        },
        missionSchedules: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/MissionSchedule'
            }
        },
        missionCompletions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/MissionCompletion'
            }
        },
        parameters: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/MissionParameter'
            }
        },
        missionRewardTickets: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/MissionTicketReward'
            }
        },
        i18n: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/MissionI18n'
            }
        },
        brand: {
            '$ref': '#/components/schemas/Brand'
        },
        identityWagerMissions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/IdentityWagerMission'
            }
        },
        brandId: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'isActive', 'type', 'theme', 'interval', 'numberOfRepetitions', 'label', 'displayOrder', 'missionSchedules', 'missionCompletions', 'parameters', 'missionRewardTickets', 'i18n', 'brand', 'identityWagerMissions', 'brandId', 'createdAt', 'updatedAt']
} as const;

export const $MissionTicketReward = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        mission: {
            '$ref': '#/components/schemas/Mission'
        },
        amount: {
            type: 'number'
        },
        ticket: {
            '$ref': '#/components/schemas/Ticket'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'mission', 'amount', 'ticket', 'createdAt', 'updatedAt']
} as const;

export const $SinglePurchaseTicketCountByTicket = {
    type: 'object',
    properties: {
        ticket: {
            '$ref': '#/components/schemas/Ticket'
        },
        ticketId: {
            type: 'string'
        },
        numberOfSoldTickets: {
            type: 'number'
        },
        numberOfSales: {
            type: 'number'
        }
    },
    required: ['ticket', 'ticketId', 'numberOfSoldTickets', 'numberOfSales']
} as const;

export const $Ticket = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        missionTickets: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/MissionTicketReward'
            }
        },
        ticketBrands: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BrandTicket'
            }
        },
        identityTicketBalance: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/IdentityTicketBalance'
            }
        },
        jackpots: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Jackpot'
            }
        },
        brandTicketOffers: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BrandTicketOffer'
            }
        },
        singlePurchaseCountByTicket: {
            '$ref': '#/components/schemas/SinglePurchaseTicketCountByTicket'
        },
        i18n: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TicketI18n'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'label', 'missionTickets', 'ticketBrands', 'identityTicketBalance', 'jackpots', 'brandTicketOffers', 'singlePurchaseCountByTicket', 'i18n', 'createdAt', 'updatedAt']
} as const;

export const $TicketI18n = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        tooltip: {
            type: 'string'
        },
        imageSrc: {
            type: 'string'
        },
        backgroundImageSrc: {
            type: 'string'
        },
        illustrationImageSrc: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/Locale'
        },
        ticket: {
            '$ref': '#/components/schemas/Ticket'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'label', 'tooltip', 'imageSrc', 'backgroundImageSrc', 'illustrationImageSrc', 'locale', 'ticket', 'createdAt', 'updatedAt']
} as const;

export const $Locale = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        localeCode: {
            type: 'string'
        },
        languageCode: {
            type: 'string'
        },
        ticketI18ns: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TicketI18n'
            }
        },
        missionI18ns: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TicketI18n'
            }
        },
        componentI18ns: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ComponentI18n'
            }
        },
        countryCode: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'localeCode', 'languageCode', 'ticketI18ns', 'missionI18ns', 'componentI18ns', 'countryCode', 'createdAt', 'updatedAt']
} as const;

export const $AdminCreateBrandConfigurationRequestDto = {
    type: 'object',
    properties: {
        localeId: {
            type: 'string'
        },
        headerSiteName: {
            type: 'string'
        },
        footerCopyright: {
            type: 'string'
        },
        footerDisclaimer: {
            type: 'string'
        }
    },
    required: ['localeId', 'headerSiteName', 'footerCopyright', 'footerDisclaimer']
} as const;

export const $AdminUpdateBrandConfigImageRequestDto = {
    type: 'object',
    properties: {
        url: {
            type: 'string'
        },
        alt: {
            type: 'string'
        },
        width: {
            type: 'number'
        },
        height: {
            type: 'number'
        },
        displayOrder: {
            type: 'number'
        }
    },
    required: ['url', 'alt', 'width', 'height', 'displayOrder']
} as const;

export const $AdminUpdateBrandConfigLinkListRequestDto = {
    type: 'object',
    properties: {
        links: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminCmsLinkRequestDto'
            }
        }
    },
    required: ['links']
} as const;

export const $AdminBrandTicketOfferI18nResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        backgroundImageSrc: {
            type: 'string'
        },
        discount: {
            type: 'string'
        },
        highlight: {
            type: 'string'
        },
        tagIntent: {
            enum: ['success', 'danger'],
            type: 'string'
        },
        tagLabel: {
            type: 'string'
        },
        buttonLabel: {
            type: 'string'
        },
        buttonTheme: {
            enum: ['default', 'primary', 'telegram', 'discrete', 'link'],
            type: 'string'
        },
        footerText: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleResponseDto'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'label', 'backgroundImageSrc', 'discount', 'highlight', 'tagIntent', 'tagLabel', 'buttonLabel', 'buttonTheme', 'footerText', 'locale', 'createdAt', 'updatedAt']
} as const;

export const $AdminBrandTicketOfferListResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        pricingModel: {
            type: 'string',
            enum: ['fixed', 'percentage']
        },
        minimumAmount: {
            type: 'number'
        },
        price: {
            type: 'string'
        },
        discountPercentage: {
            type: 'string'
        },
        isDefaultOffer: {
            type: 'boolean'
        },
        visibleFrom: {
            format: 'date-time',
            type: 'string'
        },
        starts: {
            format: 'date-time',
            type: 'string'
        },
        ends: {
            format: 'date-time',
            type: 'string'
        },
        ticket: {
            '$ref': '#/components/schemas/AdminTicketResponseDto'
        },
        i18n: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminBrandTicketOfferI18nResponseDto'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'label', 'isActive', 'pricingModel', 'minimumAmount', 'price', 'discountPercentage', 'isDefaultOffer', 'visibleFrom', 'starts', 'ends', 'ticket', 'i18n', 'createdAt', 'updatedAt']
} as const;

export const $AdminBrandTicketOfferResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        pricingModel: {
            enum: ['fixed', 'percentage'],
            type: 'string'
        },
        minimumAmount: {
            type: 'number'
        },
        price: {
            type: 'string'
        },
        discountPercentage: {
            type: 'string'
        },
        isDefaultOffer: {
            type: 'boolean'
        },
        visibleFrom: {
            format: 'date-time',
            type: 'string'
        },
        starts: {
            format: 'date-time',
            type: 'string'
        },
        ends: {
            format: 'date-time',
            type: 'string'
        },
        ticket: {
            '$ref': '#/components/schemas/AdminTicketResponseDto'
        },
        i18n: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminBrandTicketOfferI18nResponseDto'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'label', 'isActive', 'pricingModel', 'minimumAmount', 'price', 'discountPercentage', 'isDefaultOffer', 'visibleFrom', 'starts', 'ends', 'ticket', 'i18n', 'createdAt', 'updatedAt']
} as const;

export const $AdminBrandTicketOfferI18nUpdateRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        localeId: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        backgroundImageSrc: {
            type: 'string'
        },
        discount: {
            type: 'string'
        },
        highlight: {
            type: 'string'
        },
        tagIntent: {
            enum: ['success', 'danger'],
            type: 'string'
        },
        tagLabel: {
            type: 'string'
        },
        buttonLabel: {
            type: 'string'
        },
        buttonTheme: {
            enum: ['default', 'primary', 'telegram', 'discrete', 'link'],
            type: 'string'
        },
        footerText: {
            type: 'string'
        }
    },
    required: ['localeId', 'label', 'backgroundImageSrc', 'discount', 'highlight', 'tagIntent', 'tagLabel', 'buttonLabel', 'footerText']
} as const;

export const $AdminBrandTicketOfferCreateRequestDto = {
    type: 'object',
    properties: {
        label: {
            type: 'string'
        },
        ticketId: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        pricingModel: {
            type: 'string',
            enum: ['fixed', 'percentage']
        },
        minimumAmount: {
            type: 'number'
        },
        price: {
            type: 'string',
            nullable: true
        },
        discountPercentage: {
            type: 'string',
            nullable: true
        },
        isDefaultOffer: {
            type: 'boolean'
        },
        visibleFrom: {
            format: 'date-time',
            type: 'string',
            nullable: true,
            default: null
        },
        starts: {
            format: 'date-time',
            type: 'string',
            nullable: true,
            default: null
        },
        ends: {
            format: 'date-time',
            type: 'string',
            nullable: true,
            default: null
        },
        i18n: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminBrandTicketOfferI18nUpdateRequestDto'
            }
        }
    },
    required: ['label', 'ticketId', 'isActive', 'pricingModel', 'minimumAmount', 'isDefaultOffer', 'visibleFrom', 'starts', 'ends', 'i18n']
} as const;

export const $AdminBrandTicketOfferUpdateRequestDto = {
    type: 'object',
    properties: {
        label: {
            type: 'string'
        },
        ticketId: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        pricingModel: {
            type: 'string',
            enum: ['fixed', 'percentage']
        },
        minimumAmount: {
            type: 'number'
        },
        price: {
            type: 'string',
            nullable: true
        },
        discountPercentage: {
            type: 'string',
            nullable: true
        },
        isDefaultOffer: {
            type: 'boolean'
        },
        visibleFrom: {
            format: 'date-time',
            type: 'string',
            nullable: true,
            default: null
        },
        starts: {
            format: 'date-time',
            type: 'string',
            nullable: true,
            default: null
        },
        ends: {
            format: 'date-time',
            type: 'string',
            nullable: true,
            default: null
        },
        i18n: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminBrandTicketOfferI18nUpdateRequestDto'
            }
        }
    },
    required: ['label', 'ticketId', 'isActive', 'pricingModel', 'minimumAmount', 'isDefaultOffer', 'visibleFrom', 'starts', 'ends', 'i18n']
} as const;

export const $AdminBrandTicketOfferI18nListResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        backgroundImageSrc: {
            type: 'string'
        },
        discount: {
            type: 'string'
        },
        highlight: {
            type: 'string'
        },
        tagIntent: {
            type: 'string',
            enum: ['success', 'danger']
        },
        tagLabel: {
            type: 'string'
        },
        buttonLabel: {
            type: 'string'
        },
        buttonTheme: {
            type: 'string',
            enum: ['default', 'primary', 'telegram', 'discrete', 'link']
        },
        footerText: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleResponseDto'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'label', 'backgroundImageSrc', 'discount', 'highlight', 'tagIntent', 'tagLabel', 'buttonLabel', 'buttonTheme', 'footerText', 'locale', 'createdAt', 'updatedAt']
} as const;

export const $AdminBrandTicketOfferI18nCreateRequestDto = {
    type: 'object',
    properties: {
        localeId: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        backgroundImageSrc: {
            type: 'string'
        },
        discount: {
            type: 'string'
        },
        highlight: {
            type: 'string'
        },
        tagIntent: {
            type: 'string',
            enum: ['success', 'danger']
        },
        tagLabel: {
            type: 'string'
        },
        buttonLabel: {
            type: 'string'
        },
        buttonTheme: {
            type: 'string',
            enum: ['default', 'primary', 'telegram', 'discrete', 'link']
        },
        footerText: {
            type: 'string'
        }
    },
    required: ['localeId', 'label', 'backgroundImageSrc', 'discount', 'highlight', 'tagIntent', 'tagLabel', 'buttonLabel', 'buttonTheme', 'footerText']
} as const;

export const $AdminCreateBrandTicketRequestDto = {
    type: 'object',
    properties: {
        isActive: {
            type: 'boolean'
        },
        displayOrder: {
            type: 'number'
        },
        ticket: {
            '$ref': '#/components/schemas/AdminTicketDto'
        }
    },
    required: ['isActive', 'displayOrder', 'ticket']
} as const;

export const $AwsUploadFileRequestDto = {
    type: 'object',
    properties: {
        file: {
            type: 'string',
            format: 'binary'
        }
    },
    required: ['file']
} as const;

export const $AwsUploadFileResponseDto = {
    type: 'object',
    properties: {
        fileUrl: {
            type: 'string',
            example: 'https://bucket-name.s3.region.amazonaws.com/file-name.jpg'
        }
    },
    required: ['fileUrl']
} as const;

export const $AdminCreateFaqI18nRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleDto'
        },
        label: {
            type: 'string'
        },
        description: {
            type: 'string'
        }
    },
    required: ['id', 'locale', 'label', 'description']
} as const;

export const $AdminCreateFaqRequestDto = {
    type: 'object',
    properties: {
        label: {
            type: 'string'
        },
        tag: {
            type: 'string'
        },
        isActive: {
            type: 'boolean',
            default: true
        },
        i18n: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminCreateFaqI18nRequestDto'
            }
        }
    },
    required: ['label', 'tag', 'isActive', 'i18n']
} as const;

export const $AdminFaqI18nResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleResponseDto'
        },
        description: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'label', 'locale', 'description', 'createdAt', 'updatedAt']
} as const;

export const $AdminFaqQaResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        question: {
            type: 'string'
        },
        answer: {
            type: 'string'
        },
        displayOrder: {
            type: 'number'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleResponseDto'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'label', 'isActive', 'question', 'answer', 'displayOrder', 'locale', 'createdAt', 'updatedAt']
} as const;

export const $AdminFaqResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        tag: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        i18n: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminFaqI18nResponseDto'
            }
        },
        faqBrands: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminFaqBrandResponseDto'
            }
        },
        items: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminFaqQaResponseDto'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'label', 'tag', 'isActive', 'i18n', 'faqBrands', 'items', 'createdAt', 'updatedAt']
} as const;

export const $AdminFaqBrandResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        displayOrder: {
            type: 'number'
        },
        brand: {
            '$ref': '#/components/schemas/AdminBrandResponseDto'
        },
        faq: {
            '$ref': '#/components/schemas/AdminFaqResponseDto'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'isActive', 'displayOrder', 'brand', 'faq', 'createdAt', 'updatedAt']
} as const;

export const $AdminUpdateFaqI18nRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleDto'
        },
        label: {
            type: 'string'
        },
        description: {
            type: 'string'
        }
    },
    required: ['locale', 'label', 'description']
} as const;

export const $AdminUpdateFaqBrandRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        brand: {
            type: 'string'
        },
        displayOrder: {
            type: 'number'
        }
    },
    required: ['isActive', 'brand', 'displayOrder']
} as const;

export const $AdminUpdateFaqQaRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        question: {
            type: 'string'
        },
        answer: {
            type: 'string'
        },
        displayOrder: {
            type: 'number'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleDto'
        }
    },
    required: ['label', 'isActive', 'question', 'answer', 'displayOrder', 'locale']
} as const;

export const $AdminUpdateFaqRequestDto = {
    type: 'object',
    properties: {
        label: {
            type: 'string'
        },
        tag: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        i18n: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateFaqI18nRequestDto'
            }
        },
        faqBrands: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateFaqBrandRequestDto'
            }
        },
        items: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateFaqQaRequestDto'
            }
        }
    },
    required: ['label', 'tag', 'isActive', 'i18n', 'faqBrands', 'items']
} as const;

export const $AdminCreateFaqBrandRequestDto = {
    type: 'object',
    properties: {
        brandId: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        displayOrder: {
            type: 'number'
        }
    },
    required: ['brandId', 'isActive', 'displayOrder']
} as const;

export const $AdminCreateFaqQaRequestDto = {
    type: 'object',
    properties: {
        faqId: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleDto'
        },
        label: {
            type: 'string'
        },
        isActive: {
            type: 'boolean',
            default: false
        },
        question: {
            type: 'string'
        },
        answer: {
            type: 'string'
        },
        displayOrder: {
            type: 'number',
            default: 0
        }
    },
    required: ['faqId', 'locale', 'label', 'isActive', 'question', 'answer', 'displayOrder']
} as const;

export const $AdminCreateLocaleRequestDto = {
    type: 'object',
    properties: {
        localeCode: {
            type: 'string',
            minLength: 2,
            maxLength: 15,
            example: 'en-US'
        },
        languageCode: {
            type: 'string',
            minLength: 2,
            maxLength: 3,
            example: 'en'
        },
        countryCode: {
            type: 'string',
            minLength: 2,
            maxLength: 3,
            example: 'US'
        }
    },
    required: ['localeCode', 'languageCode', 'countryCode']
} as const;

export const $AdminUpdateLocaleRequestDto = {
    type: 'object',
    properties: {
        localeCode: {
            type: 'string',
            minLength: 2,
            maxLength: 15,
            example: 'en-US'
        },
        languageCode: {
            type: 'string',
            minLength: 2,
            maxLength: 3,
            example: 'en'
        },
        countryCode: {
            type: 'string',
            minLength: 2,
            maxLength: 3,
            example: 'US'
        }
    },
    required: ['localeCode', 'languageCode', 'countryCode']
} as const;

export const $AdminJackpotAcceptanceConditionParameterResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        key: {
            type: 'string'
        },
        value: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'key', 'value', 'createdAt', 'updatedAt']
} as const;

export const $AdminJackpotAcceptanceConditionResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        type: {
            enum: ['ticketOwnership', 'nftOwnership', 'missionCompletion', 'missionTypeCompletion'],
            type: 'string'
        },
        parameters: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminJackpotAcceptanceConditionParameterResponseDto'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'type', 'parameters', 'createdAt', 'updatedAt']
} as const;

export const $AdminProfileResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        identity: {
            description: 'Associated identity',
            allOf: [
                {
                    '$ref': '#/components/schemas/AdminIdentityResponseDto'
                }
            ]
        },
        name: {
            type: 'string',
            description: 'Name of the profile'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'identity', 'name', 'createdAt', 'updatedAt']
} as const;

export const $AdminIdentityResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            description: 'ID of the identity'
        },
        brand: {
            description: 'Associated brand',
            allOf: [
                {
                    '$ref': '#/components/schemas/AdminBrandResponseDto'
                }
            ]
        },
        profile: {
            description: 'Associated profile',
            allOf: [
                {
                    '$ref': '#/components/schemas/AdminProfileResponseDto'
                }
            ]
        },
        createdAt: {
            format: 'date-time',
            type: 'string',
            description: 'Creation timestamp'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string',
            description: 'Last update timestamp'
        }
    },
    required: ['id', 'brand', 'profile', 'createdAt', 'updatedAt']
} as const;

export const $AdminJackpotPrizeResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        amount: {
            type: 'string'
        },
        currency: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'amount', 'currency', 'createdAt', 'updatedAt']
} as const;

export const $AdminDrawnEntryResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        identity: {
            description: 'Associated identity',
            allOf: [
                {
                    '$ref': '#/components/schemas/AdminIdentityResponseDto'
                }
            ]
        },
        prize: {
            description: 'Associated prize',
            allOf: [
                {
                    '$ref': '#/components/schemas/AdminJackpotPrizeResponseDto'
                }
            ]
        },
        poolEntry: {
            description: 'Associated pool entry',
            allOf: [
                {
                    '$ref': '#/components/schemas/AdminPoolEntryResponseDto'
                }
            ]
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'identity', 'prize', 'createdAt', 'updatedAt']
} as const;

export const $AdminMissionTicketRewardResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        amount: {
            type: 'number',
            description: 'Amount of the reward'
        },
        missionId: {
            type: 'string',
            description: 'ID of the associated mission'
        },
        ticket: {
            description: 'Associated ticket',
            allOf: [
                {
                    '$ref': '#/components/schemas/AdminTicketResponseDto'
                }
            ]
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'amount', 'missionId', 'ticket', 'createdAt', 'updatedAt']
} as const;

export const $AdminLedgerEntryResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        identity: {
            '$ref': '#/components/schemas/AdminIdentityResponseDto'
        },
        transactionType: {
            enum: ['jackpotDraw', 'missionReward', 'revertMissionReward', 'ticketPurchase', 'ticketConversion', 'bet', 'refund'],
            type: 'string'
        },
        ticketAmount: {
            type: 'number',
            description: 'Amount of tickets involved in the transaction'
        },
        balanceAfterTransaction: {
            type: 'number',
            description: 'Balance after the transaction'
        },
        transactionCounterPart: {
            '$ref': '#/components/schemas/AdminLedgerEntryResponseDto'
        },
        ticket: {
            description: 'Associated ticket',
            allOf: [
                {
                    '$ref': '#/components/schemas/AdminTicketResponseDto'
                }
            ]
        },
        missionTicketReward: {
            description: 'Associated mission ticket reward',
            allOf: [
                {
                    '$ref': '#/components/schemas/AdminMissionTicketRewardResponseDto'
                }
            ]
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'identity', 'transactionType', 'ticketAmount', 'balanceAfterTransaction', 'createdAt', 'updatedAt']
} as const;

export const $AdminPoolEntryResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        poolId: {
            type: 'string'
        },
        drawnEntry: {
            nullable: true,
            allOf: [
                {
                    '$ref': '#/components/schemas/AdminDrawnEntryResponseDto'
                }
            ]
        },
        ledgerEntry: {
            '$ref': '#/components/schemas/AdminLedgerEntryResponseDto'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'poolId', 'drawnEntry', 'ledgerEntry', 'createdAt', 'updatedAt']
} as const;

export const $AdminJackpotBrandResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        displayOrder: {
            type: 'number'
        },
        brand: {
            '$ref': '#/components/schemas/AdminBrandResponseDto'
        },
        jackpot: {
            '$ref': '#/components/schemas/AdminJackpotResponseDto'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'isActive', 'displayOrder', 'brand', 'jackpot', 'createdAt', 'updatedAt']
} as const;

export const $AdminPagesBrandHostResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        hostname: {
            type: 'string'
        }
    },
    required: ['id', 'hostname']
} as const;

export const $AdminPagesBrandResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        hosts: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminPagesBrandHostResponseDto'
            }
        }
    },
    required: ['id', 'label', 'hosts']
} as const;

export const $AdminJackpotPageRouteResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        slug: {
            type: 'string'
        },
        access: {
            type: 'string',
            enum: ['guest', 'user']
        },
        brand: {
            '$ref': '#/components/schemas/AdminPagesBrandResponseDto'
        },
        isEnabled: {
            type: 'boolean'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'slug', 'access', 'brand', 'isEnabled', 'createdAt', 'updatedAt']
} as const;

export const $AdminJackpotI18nResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        tooltip: {
            type: 'string'
        },
        imageSrc: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        heroImageSrc: {
            type: 'string'
        },
        prizeDescription: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleDto'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        },
        pageRoute: {
            '$ref': '#/components/schemas/AdminJackpotPageRouteResponseDto'
        }
    },
    required: ['label', 'tooltip', 'imageSrc', 'title', 'description', 'heroImageSrc', 'prizeDescription', 'locale', 'createdAt', 'updatedAt', 'pageRoute']
} as const;

export const $AdminJackpotResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        logicalOperator: {
            enum: ['AND', 'OR'],
            type: 'string'
        },
        theme: {
            enum: ['gold', 'silver', 'bronze'],
            type: 'string'
        },
        timezone: {
            type: 'string'
        },
        interval: {
            type: 'string'
        },
        numberOfRepetitions: {
            type: 'number',
            nullable: true
        },
        from: {
            format: 'date-time',
            type: 'string',
            nullable: true
        },
        until: {
            format: 'date-time',
            type: 'string',
            nullable: true
        },
        baseTicket: {
            type: 'object',
            properties: {
                id: {
                    required: true,
                    type: 'string'
                },
                label: {
                    required: true,
                    type: 'string'
                }
            }
        },
        jackpotAcceptanceConditions: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminJackpotAcceptanceConditionResponseDto'
            }
        },
        pools: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminPoolResponseDto'
            }
        },
        brandJackpots: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminJackpotBrandResponseDto'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        },
        brandId: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        i18n: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminJackpotI18nResponseDto'
            }
        }
    },
    required: ['id', 'label', 'logicalOperator', 'theme', 'timezone', 'interval', 'numberOfRepetitions', 'from', 'until', 'baseTicket', 'jackpotAcceptanceConditions', 'pools', 'brandJackpots', 'createdAt', 'updatedAt', 'brandId', 'isActive', 'i18n']
} as const;

export const $AdminDrawResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        randomSeed: {
            type: 'number',
            description: 'Random seed used for the draw'
        },
        selectionAlgorithm: {
            type: 'number',
            description: 'Selection algorithm used for the draw'
        },
        algorithmVersion: {
            type: 'number',
            description: 'Algorithm version used for the draw'
        },
        pool: {
            description: 'Associated pool',
            allOf: [
                {
                    '$ref': '#/components/schemas/AdminPoolResponseDto'
                }
            ]
        },
        winners: {
            description: 'List of drawn winners',
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminDrawnEntryResponseDto'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'randomSeed', 'selectionAlgorithm', 'algorithmVersion', 'pool', 'winners', 'createdAt', 'updatedAt']
} as const;

export const $AdminPoolResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        poolStart: {
            format: 'date-time',
            type: 'string',
            description: 'Start date of the pool'
        },
        poolEnd: {
            format: 'date-time',
            type: 'string',
            description: 'End date of the pool'
        },
        entries: {
            description: 'Entries in the pool',
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminPoolEntryResponseDto'
            }
        },
        jackpot: {
            description: 'Associated jackpot',
            allOf: [
                {
                    '$ref': '#/components/schemas/AdminJackpotResponseDto'
                }
            ]
        },
        draw: {
            '$ref': '#/components/schemas/AdminDrawResponseDto'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'poolStart', 'poolEnd', 'entries', 'jackpot', 'createdAt', 'updatedAt']
} as const;

export const $AdminCreateJackpotRequestDto = {
    type: 'object',
    properties: {
        label: {
            type: 'string',
            minLength: 1,
            maxLength: 100
        },
        isActive: {
            type: 'boolean'
        },
        timezone: {
            type: 'string',
            maxLength: 50
        },
        logicalOperator: {
            type: 'string',
            default: 'AND',
            enum: ['AND', 'OR']
        },
        theme: {
            type: 'string',
            default: 'gold',
            enum: ['gold', 'silver', 'bronze']
        },
        interval: {
            type: 'string',
            default: 'yearly',
            enum: ['once', 'daily', 'weekly', 'monthly', 'quarterly', 'yearly']
        },
        numberOfRepetitions: {
            type: 'number',
            nullable: true,
            default: null
        },
        from: {
            format: 'date-time',
            type: 'string',
            nullable: true,
            default: null
        },
        until: {
            format: 'date-time',
            type: 'string',
            nullable: true,
            default: null
        },
        baseTicketId: {
            type: 'string'
        }
    },
    required: ['label', 'isActive', 'timezone', 'logicalOperator', 'theme', 'interval', 'numberOfRepetitions', 'from', 'until', 'baseTicketId']
} as const;

export const $AdminUpdateJackpotPrizeDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        amount: {
            type: 'string'
        },
        currency: {
            type: 'string'
        }
    },
    required: ['amount', 'currency']
} as const;

export const $AdminUpdateJackpotI18nRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        tooltip: {
            type: 'string'
        },
        imageSrc: {
            type: 'string'
        },
        prizeDescription: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        heroImageSrc: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleDto'
        },
        pageRouteId: {
            type: 'string'
        }
    },
    required: ['label', 'tooltip', 'imageSrc', 'prizeDescription', 'title', 'description', 'heroImageSrc', 'locale', 'pageRouteId']
} as const;

export const $AdminJackpotAcceptanceConditionParameterDto = {
    type: 'object',
    properties: {
        key: {
            type: 'string',
            enum: ['ticketId', 'condition', 'ticketCount', 'nftAddress', 'missionId', 'missionType']
        },
        value: {
            type: 'string'
        }
    },
    required: ['key', 'value']
} as const;

export const $AdminUpdateJackpotAcceptanceConditionRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        type: {
            enum: ['ticketOwnership', 'nftOwnership', 'missionCompletion', 'missionTypeCompletion'],
            type: 'string'
        },
        parameters: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminJackpotAcceptanceConditionParameterDto'
            }
        }
    },
    required: ['type']
} as const;

export const $AdminUpdateDrawRequestDto = {
    type: 'object',
    properties: {
        randomSeed: {
            type: 'number'
        },
        selectionAlgorithm: {
            type: 'string'
        },
        algorithmVersion: {
            type: 'number'
        },
        poolId: {
            type: 'string'
        }
    }
} as const;

export const $AdminUpdatePoolRequestDto = {
    type: 'object',
    properties: {
        poolStart: {
            format: 'date-time',
            type: 'string',
            description: 'Start date of the pool'
        },
        poolEnd: {
            format: 'date-time',
            type: 'string',
            description: 'End date of the pool'
        },
        jackpotId: {
            type: 'string',
            description: 'ID of the associated jackpot'
        },
        draw: {
            description: 'Draw details for updating',
            allOf: [
                {
                    '$ref': '#/components/schemas/AdminUpdateDrawRequestDto'
                }
            ]
        },
        id: {
            type: 'string'
        }
    }
} as const;

export const $AdminUpdateJackpotBrandRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        brand: {
            type: 'string'
        },
        displayOrder: {
            type: 'number'
        }
    },
    required: ['displayOrder']
} as const;

export const $AdminUpdateJackpotRequestDto = {
    type: 'object',
    properties: {
        label: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        timezone: {
            type: 'string',
            maxLength: 50
        },
        logicalOperator: {
            type: 'string',
            enum: ['AND', 'OR']
        },
        theme: {
            type: 'string',
            default: 'gold',
            enum: ['gold', 'silver', 'bronze']
        },
        interval: {
            type: 'string',
            enum: ['once', 'daily', 'weekly', 'monthly', 'quarterly', 'yearly']
        },
        numberOfRepetitions: {
            type: 'number',
            nullable: true
        },
        from: {
            format: 'date-time',
            type: 'string',
            nullable: true
        },
        until: {
            format: 'date-time',
            type: 'string',
            nullable: true
        },
        baseTicketId: {
            type: 'string'
        },
        prizes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateJackpotPrizeDto'
            }
        },
        i18n: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateJackpotI18nRequestDto'
            }
        },
        jackpotAcceptanceConditions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateJackpotAcceptanceConditionRequestDto'
            }
        },
        pools: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdatePoolRequestDto'
            }
        },
        brandJackpots: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateJackpotBrandRequestDto'
            }
        }
    },
    required: ['isActive', 'logicalOperator', 'theme']
} as const;

export const $AdminCreateJackpotPrizeRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        amount: {
            type: 'string'
        },
        currency: {
            type: 'string'
        }
    },
    required: ['amount', 'currency']
} as const;

export const $AdminCreateJackpotAcceptanceConditionRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        type: {
            type: 'string',
            enum: ['ticketOwnership', 'nftOwnership', 'missionCompletion', 'missionTypeCompletion']
        },
        parameters: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminJackpotAcceptanceConditionParameterDto'
            }
        }
    },
    required: ['type']
} as const;

export const $AdminCreateJackpotI18nRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        tooltip: {
            type: 'string'
        },
        prizeDescription: {
            type: 'string'
        },
        imageSrc: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        heroImageSrc: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleDto'
        },
        pageRouteId: {
            type: 'string'
        }
    },
    required: ['label', 'tooltip', 'prizeDescription', 'imageSrc', 'title', 'description', 'heroImageSrc', 'locale', 'pageRouteId']
} as const;

export const $AdminCreateDrawRequestDto = {
    type: 'object',
    properties: {
        randomSeed: {
            type: 'number',
            description: 'Random seed used for the draw'
        },
        selectionAlgorithm: {
            type: 'string',
            description: 'Selection algorithm used for the draw'
        },
        algorithmVersion: {
            type: 'number',
            description: 'Version of the algorithm used'
        },
        poolId: {
            type: 'string',
            description: 'ID of the associated pool'
        }
    },
    required: ['randomSeed', 'selectionAlgorithm', 'algorithmVersion']
} as const;

export const $AdminCreatePoolRequestDto = {
    type: 'object',
    properties: {
        poolStart: {
            format: 'date-time',
            type: 'string',
            description: 'Start date of the pool'
        },
        poolEnd: {
            format: 'date-time',
            type: 'string',
            description: 'End date of the pool'
        },
        jackpotId: {
            type: 'string',
            description: 'ID of the associated jackpot'
        },
        draw: {
            description: 'Draw details (if creating a new draw)',
            allOf: [
                {
                    '$ref': '#/components/schemas/AdminCreateDrawRequestDto'
                }
            ]
        }
    },
    required: ['poolStart', 'poolEnd', 'jackpotId']
} as const;

export const $AdminCreateJackpotBrandRequestDto = {
    type: 'object',
    properties: {
        brandId: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        displayOrder: {
            type: 'number'
        }
    },
    required: ['brandId', 'isActive', 'displayOrder']
} as const;

export const $AdminCreateTicketRequestDto = {
    type: 'object',
    properties: {
        label: {
            type: 'string'
        }
    },
    required: ['label']
} as const;

export const $AdminUpdateTicketRequestDto = {
    type: 'object',
    properties: {
        label: {
            type: 'string'
        },
        i18n: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateTicketI18nRequestDto'
            }
        }
    }
} as const;

export const $AdminCreateTicketI18nRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string',
            minLength: 3,
            maxLength: 100
        },
        tooltip: {
            type: 'string',
            minLength: 5,
            maxLength: 255
        },
        imageSrc: {
            type: 'string',
            minLength: 5,
            maxLength: 255
        },
        backgroundImageSrc: {
            type: 'string'
        },
        illustrationImageSrc: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleDto'
        }
    },
    required: ['label', 'tooltip', 'imageSrc', 'backgroundImageSrc', 'illustrationImageSrc', 'locale']
} as const;

export const $AdminScheduleResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        from: {
            format: 'date-time',
            type: 'string',
            nullable: true,
            default: null
        },
        until: {
            format: 'date-time',
            type: 'string',
            nullable: true,
            default: null
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'from', 'until', 'createdAt', 'updatedAt']
} as const;

export const $AdminMissionScheduleResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        schedule: {
            description: 'Associated schedule',
            allOf: [
                {
                    '$ref': '#/components/schemas/AdminScheduleResponseDto'
                }
            ]
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'schedule', 'createdAt', 'updatedAt']
} as const;

export const $MissionParameterKey = {
    type: 'string',
    description: 'Key of the parameter',
    enum: ['telegramBotId', 'telegramChatId', 'discordChannelId', 'discordChannelJoinLink', 'twitterAccountId', 'twitterAccountAddress', 'youtubeChannelId', 'youtubeChannelAddress', 'nftCollectionId', 'tokenId', 'balanceMin', 'product', 'wagerAmount', 'gameId', 'gameProvider', 'gameType', 'stakedTokenAddress', 'minStakedAmount']
} as const;

export const $AdminMissionParameterResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        key: {
            '$ref': '#/components/schemas/MissionParameterKey'
        },
        value: {
            type: 'string',
            description: 'Value of the parameter'
        },
        missionId: {
            type: 'string',
            description: 'ID of the associated mission'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['key', 'value', 'missionId', 'createdAt', 'updatedAt']
} as const;

export const $AdminMissionI18nResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        badgeLabel: {
            type: 'string'
        },
        link: {
            type: 'string'
        },
        linkTheme: {
            enum: ['default', 'primary'],
            type: 'string'
        },
        linkLabel: {
            type: 'string'
        },
        tooltip: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        imageSrc: {
            type: 'string'
        },
        backgroundImageSrc: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleDto'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['title', 'badgeLabel', 'link', 'linkTheme', 'linkLabel', 'tooltip', 'description', 'imageSrc', 'backgroundImageSrc', 'locale', 'createdAt', 'updatedAt']
} as const;

export const $AdminMissionResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        isActive: {
            type: 'boolean'
        },
        type: {
            enum: ['register', 'login', 'inviteFriend', 'wager', 'nft', 'token', 'twitterFollow', 'youtubeFollow', 'telegramJoin', 'discordJoin', 'stakeTokens'],
            type: 'string'
        },
        theme: {
            enum: ['gold', 'silver', 'bronze'],
            type: 'string'
        },
        interval: {
            enum: ['always', 'once', 'hourly', 'daily', 'weekly', 'monthly', 'quarterly', 'yearly'],
            type: 'string'
        },
        label: {
            type: 'string'
        },
        displayOrder: {
            type: 'number'
        },
        brand: {
            description: 'Associated brand',
            allOf: [
                {
                    '$ref': '#/components/schemas/AdminBrandResponseDto'
                }
            ]
        },
        missionSchedules: {
            default: [],
            description: 'Schedules of the mission',
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminMissionScheduleResponseDto'
            }
        },
        parameters: {
            default: [],
            description: 'Parameters of the mission',
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminMissionParameterResponseDto'
            }
        },
        missionRewardTickets: {
            default: [],
            description: 'Reward tickets of the mission',
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminMissionTicketRewardResponseDto'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        },
        i18n: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminMissionI18nResponseDto'
            }
        }
    },
    required: ['id', 'isActive', 'type', 'theme', 'interval', 'label', 'displayOrder', 'brand', 'missionSchedules', 'parameters', 'missionRewardTickets', 'createdAt', 'updatedAt', 'i18n']
} as const;

export const $AdminCreateMissionParameterRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            description: 'ID of the mission parameter'
        },
        key: {
            enum: ['telegramBotId', 'telegramChatId', 'discordChannelId', 'discordChannelJoinLink', 'twitterAccountId', 'twitterAccountAddress', 'youtubeChannelId', 'youtubeChannelAddress', 'nftCollectionId', 'tokenId', 'balanceMin', 'product', 'wagerAmount', 'gameId', 'gameProvider', 'gameType', 'stakedTokenAddress', 'minStakedAmount'],
            type: 'string',
            description: 'Key of the parameter'
        },
        value: {
            type: 'string',
            description: 'Value of the parameter'
        }
    },
    required: ['key', 'value']
} as const;

export const $AdminCreateMissionRequestDto = {
    type: 'object',
    properties: {
        type: {
            enum: ['register', 'login', 'inviteFriend', 'wager', 'nft', 'token', 'twitterFollow', 'youtubeFollow', 'telegramJoin', 'discordJoin', 'stakeTokens'],
            type: 'string',
            description: 'Type of the mission'
        },
        theme: {
            enum: ['gold', 'silver', 'bronze'],
            type: 'string',
            description: 'Theme of the mission'
        },
        interval: {
            enum: ['always', 'once', 'hourly', 'daily', 'weekly', 'monthly', 'quarterly', 'yearly'],
            type: 'string',
            description: 'Interval of the mission'
        },
        label: {
            type: 'string',
            minLength: 1,
            maxLength: 100,
            description: 'Label of the mission'
        },
        brandId: {
            type: 'string',
            description: 'ID of the associated brand'
        },
        parameters: {
            description: 'Parameters of the mission',
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminCreateMissionParameterRequestDto'
            }
        },
        isActive: {
            type: 'boolean'
        },
        displayOrder: {
            type: 'number'
        }
    },
    required: ['type', 'theme', 'interval', 'label', 'brandId', 'isActive', 'displayOrder']
} as const;

export const $AdminUpdateScheduleRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        from: {
            format: 'date-time',
            type: 'string',
            nullable: true,
            default: null
        },
        until: {
            format: 'date-time',
            type: 'string',
            nullable: true,
            default: null
        }
    }
} as const;

export const $AdminUpdateMissionScheduleRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        schedule: {
            '$ref': '#/components/schemas/AdminUpdateScheduleRequestDto'
        }
    }
} as const;

export const $AdminUpdateMissionParameterRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            description: 'ID of the mission parameter'
        },
        key: {
            enum: ['telegramBotId', 'telegramChatId', 'discordChannelId', 'discordChannelJoinLink', 'twitterAccountId', 'twitterAccountAddress', 'youtubeChannelId', 'youtubeChannelAddress', 'nftCollectionId', 'tokenId', 'balanceMin', 'product', 'wagerAmount', 'gameId', 'gameProvider', 'gameType', 'stakedTokenAddress', 'minStakedAmount'],
            type: 'string',
            description: 'Key of the parameter'
        },
        value: {
            type: 'string',
            description: 'Value of the parameter'
        },
        missionId: {
            type: 'string',
            description: 'ID of the associated mission'
        }
    }
} as const;

export const $AdminUpdateMissionTicketRewardRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        amount: {
            type: 'number'
        },
        missionId: {
            type: 'string'
        },
        ticket: {
            '$ref': '#/components/schemas/AdminTicketDto'
        }
    },
    required: ['amount', 'ticket']
} as const;

export const $AdminUpdateMissionI18nRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        badgeLabel: {
            type: 'string'
        },
        link: {
            type: 'string'
        },
        linkTheme: {
            enum: ['default', 'primary'],
            type: 'string'
        },
        linkLabel: {
            type: 'string'
        },
        tooltip: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        imageSrc: {
            type: 'string'
        },
        backgroundImageSrc: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleDto'
        }
    },
    required: ['title', 'badgeLabel', 'link', 'linkTheme', 'linkLabel', 'tooltip', 'description', 'imageSrc', 'backgroundImageSrc', 'locale']
} as const;

export const $AdminUpdateMissionRequestDto = {
    type: 'object',
    properties: {
        isActive: {
            type: 'boolean'
        },
        type: {
            type: 'string',
            enum: ['register', 'login', 'inviteFriend', 'wager', 'nft', 'token', 'twitterFollow', 'youtubeFollow', 'telegramJoin', 'discordJoin', 'stakeTokens']
        },
        theme: {
            type: 'string',
            enum: ['gold', 'silver', 'bronze']
        },
        interval: {
            type: 'string',
            enum: ['always', 'once', 'hourly', 'daily', 'weekly', 'monthly', 'quarterly', 'yearly']
        },
        label: {
            type: 'string'
        },
        displayOrder: {
            type: 'number'
        },
        missionSchedules: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateMissionScheduleRequestDto'
            }
        },
        parameters: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateMissionParameterRequestDto'
            }
        },
        missionRewardTickets: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateMissionTicketRewardRequestDto'
            }
        },
        i18n: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateMissionI18nRequestDto'
            }
        },
        brandId: {
            type: 'string'
        }
    },
    required: ['isActive', 'type', 'theme', 'interval', 'label', 'displayOrder', 'missionSchedules', 'parameters', 'missionRewardTickets', 'i18n', 'brandId']
} as const;

export const $AdminCreateMissionI18nRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        badgeLabel: {
            type: 'string'
        },
        link: {
            type: 'string'
        },
        linkTheme: {
            type: 'string',
            enum: ['default', 'primary']
        },
        linkLabel: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        tooltip: {
            type: 'string'
        },
        imageSrc: {
            type: 'string'
        },
        backgroundImageSrc: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminLocaleDto'
        }
    },
    required: ['title', 'badgeLabel', 'link', 'linkTheme', 'linkLabel', 'description', 'tooltip', 'imageSrc', 'backgroundImageSrc', 'locale']
} as const;

export const $AdminCreateScheduleRequestDto = {
    type: 'object',
    properties: {
        from: {
            format: 'date-time',
            type: 'string',
            nullable: true,
            default: null
        },
        until: {
            format: 'date-time',
            type: 'string',
            nullable: true,
            default: null
        },
        missionScheduleId: {
            type: 'string'
        }
    }
} as const;

export const $AdminCreateMissionScheduleRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        schedule: {
            '$ref': '#/components/schemas/AdminCreateScheduleRequestDto'
        }
    },
    required: ['schedule']
} as const;

export const $AdminCreateMissionTicketRewardRequestDto = {
    type: 'object',
    properties: {
        amount: {
            type: 'number',
            description: 'Amount of the reward'
        },
        missionId: {
            type: 'string',
            description: 'ID of the associated mission'
        },
        ticket: {
            '$ref': '#/components/schemas/AdminTicketDto'
        }
    },
    required: ['amount', 'missionId', 'ticket']
} as const;

export const $AdminCreateIdentityRequestDto = {
    type: 'object',
    properties: {
        brandId: {
            type: 'string',
            description: 'ID of the associated brand'
        },
        profileId: {
            type: 'string',
            description: 'ID of the associated profile'
        }
    },
    required: ['brandId', 'profileId']
} as const;

export const $AdminUpdateIdentityTicketBalanceRequestDto = {
    type: 'object',
    properties: {
        ticketId: {
            type: 'string',
            description: 'ID of the associated ticket'
        },
        amount: {
            type: 'number',
            description: 'Amount for the ticket balance'
        }
    }
} as const;

export const $AdminUpdateLedgerEntryRequestDto = {
    type: 'object',
    properties: {
        identityId: {
            type: 'string',
            description: 'ID of the associated identity'
        },
        transactionType: {
            enum: ['jackpotDraw', 'missionReward', 'revertMissionReward', 'ticketPurchase', 'ticketConversion', 'bet', 'refund'],
            type: 'string',
            description: 'Type of the transaction'
        },
        ticketAmount: {
            type: 'number',
            description: 'Amount of tickets involved in the transaction'
        },
        balanceAfterTransaction: {
            type: 'number',
            description: 'Balance after the transaction'
        },
        ticketId: {
            type: 'string',
            description: 'ID of the associated ticket'
        },
        missionTicketRewardId: {
            type: 'string',
            description: 'ID of the associated mission ticket reward'
        },
        transactionCounterPartId: {
            type: 'string',
            description: 'ID of the transaction counterpart'
        }
    }
} as const;

export const $AdminUpdateDrawnEntryRequestDto = {
    type: 'object',
    properties: {
        drawId: {
            type: 'string',
            description: 'ID of the associated draw'
        },
        poolEntryId: {
            type: 'string',
            description: 'ID of the associated pool entry'
        },
        identityId: {
            type: 'string',
            description: 'ID of the associated identity'
        },
        prizeId: {
            type: 'string',
            description: 'ID of the associated prize'
        }
    }
} as const;

export const $AdminUpdateIdentityRequestDto = {
    type: 'object',
    properties: {
        brandId: {
            type: 'string',
            description: 'ID of the associated brand'
        },
        profileId: {
            type: 'string',
            description: 'ID of the associated profile'
        },
        ticketBalance: {
            description: 'Ticket balances associated with the identity',
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateIdentityTicketBalanceRequestDto'
            }
        },
        ledgerEntries: {
            description: 'Ledger entries associated with the identity',
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateLedgerEntryRequestDto'
            }
        },
        drawnEntries: {
            description: 'Drawn entries associated with the identity',
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminUpdateDrawnEntryRequestDto'
            }
        }
    }
} as const;

export const $AdminCreateDrawnEntryRequestDto = {
    type: 'object',
    properties: {
        drawId: {
            type: 'string',
            description: 'ID of the associated draw'
        },
        poolEntryId: {
            type: 'string',
            description: 'ID of the associated pool entry'
        },
        identityId: {
            type: 'string',
            description: 'ID of the associated identity'
        },
        prizeId: {
            type: 'string',
            description: 'ID of the associated prize'
        }
    },
    required: ['drawId', 'identityId', 'prizeId']
} as const;

export const $LoginDto = {
    type: 'object',
    properties: {
        username: {
            type: 'string'
        },
        password: {
            type: 'string',
            minLength: 4
        }
    },
    required: ['username', 'password']
} as const;

export const $LoginResponseDto = {
    type: 'object',
    properties: {
        token: {
            type: 'string'
        },
        expiresIn: {
            type: 'number'
        },
        message: {
            type: 'string'
        }
    },
    required: ['token', 'expiresIn', 'message']
} as const;

export const $AdminWinnerDrawPoolJackpotDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        }
    },
    required: ['id', 'label']
} as const;

export const $AdminWinnerDrawPoolDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        jackpot: {
            '$ref': '#/components/schemas/AdminWinnerDrawPoolJackpotDto'
        },
        number: {
            type: 'number'
        },
        status: {
            type: 'string',
            enum: ['OPEN', 'CLOSED']
        },
        poolStart: {
            format: 'date-time',
            type: 'string'
        },
        poolEnd: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'jackpot', 'number', 'status', 'poolStart', 'poolEnd']
} as const;

export const $AdminWinnerDrawDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        randomSeed: {
            type: 'number'
        },
        selectionAlgorithm: {
            type: 'string'
        },
        pool: {
            '$ref': '#/components/schemas/AdminWinnerDrawPoolDto'
        },
        algorithmVersion: {
            type: 'number'
        },
        drawDate: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'randomSeed', 'selectionAlgorithm', 'pool', 'algorithmVersion', 'drawDate']
} as const;

export const $AdminWinnerIdentityBrandDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        }
    },
    required: ['id', 'label']
} as const;

export const $AdminWinnerIdentityProfileDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        fullName: {
            type: 'string'
        },
        firstName: {
            type: 'string'
        },
        middleName: {
            type: 'string'
        },
        nickName: {
            type: 'string'
        },
        email: {
            type: 'string'
        }
    },
    required: ['id', 'fullName', 'firstName', 'middleName', 'nickName', 'email']
} as const;

export const $AdminWinnerIdentityCredentialDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        type: {
            type: 'string',
            enum: ['bhg', 'telegram']
        },
        bhgAccountId: {
            type: 'string'
        },
        bhgBrandId: {
            type: 'string'
        },
        telegramId: {
            type: 'number'
        },
        telegramUsername: {
            type: 'string'
        }
    },
    required: ['id', 'type', 'bhgAccountId', 'bhgBrandId', 'telegramId', 'telegramUsername']
} as const;

export const $AdminWinnerIdentityDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        brand: {
            '$ref': '#/components/schemas/AdminWinnerIdentityBrandDto'
        },
        profile: {
            '$ref': '#/components/schemas/AdminWinnerIdentityProfileDto'
        },
        credentials: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminWinnerIdentityCredentialDto'
            }
        },
        randomSeed: {
            type: 'number'
        },
        selectionAlgorithm: {
            type: 'string'
        },
        algorithmVersion: {
            type: 'number'
        },
        drawDate: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'brand', 'profile', 'credentials', 'randomSeed', 'selectionAlgorithm', 'algorithmVersion', 'drawDate']
} as const;

export const $AdminWinnerResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        draw: {
            '$ref': '#/components/schemas/AdminWinnerDrawDto'
        },
        identity: {
            '$ref': '#/components/schemas/AdminWinnerIdentityDto'
        },
        ticketCount: {
            type: 'number'
        },
        winChance: {
            type: 'number'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'draw', 'identity', 'ticketCount', 'winChance', 'createdAt']
} as const;

export const $AdminDebugBrandDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        }
    },
    required: ['id', 'label']
} as const;

export const $AdminDebugProfileDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        fullName: {
            type: 'string'
        },
        firstName: {
            type: 'string'
        },
        middleName: {
            type: 'string'
        },
        lastName: {
            type: 'string'
        },
        nickName: {
            type: 'string'
        },
        email: {
            type: 'string'
        },
        referralCode: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'fullName', 'firstName', 'middleName', 'lastName', 'nickName', 'email', 'referralCode', 'createdAt', 'updatedAt']
} as const;

export const $AdminDebugWalletDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        address: {
            type: 'string'
        },
        status: {
            type: 'string',
            enum: ['connected', 'verified', 'invalid']
        },
        nonce: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'address', 'status', 'nonce', 'createdAt', 'updatedAt']
} as const;

export const $AdminDebugMissionDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        }
    },
    required: ['id', 'label']
} as const;

export const $AdminDebugMissionCompletionDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        mission: {
            '$ref': '#/components/schemas/AdminDebugMissionDto'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'mission', 'createdAt', 'updatedAt']
} as const;

export const $AdminDebugCredentialDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        type: {
            type: 'string',
            enum: ['bhg', 'telegram']
        },
        bhgAccountId: {
            type: 'string'
        },
        bhgBrandId: {
            type: 'string'
        },
        telegramId: {
            type: 'number'
        },
        telegramUsername: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'type', 'bhgAccountId', 'bhgBrandId', 'telegramId', 'telegramUsername', 'createdAt', 'updatedAt']
} as const;

export const $AdminDebugTicketDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        }
    },
    required: ['id', 'label']
} as const;

export const $AdminDebugTicketBalanceDto = {
    type: 'object',
    properties: {
        ticketId: {
            type: 'string'
        },
        ticketAmount: {
            type: 'number'
        },
        ticket: {
            '$ref': '#/components/schemas/AdminDebugTicketDto'
        }
    },
    required: ['ticketId', 'ticketAmount', 'ticket']
} as const;

export const $AdminDebugSinglePurchaseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        offerLabel: {
            type: 'string'
        },
        ticketId: {
            type: 'string'
        },
        offerPricingModel: {
            type: 'string'
        },
        ticketAmount: {
            type: 'number'
        },
        orderTotalInOfferCurrency: {
            type: 'string'
        },
        status: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'offerLabel', 'ticketId', 'offerPricingModel', 'ticketAmount', 'orderTotalInOfferCurrency', 'status', 'createdAt', 'updatedAt']
} as const;

export const $AdminDebugUserListResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        isBanned: {
            type: 'boolean'
        },
        isTestAccount: {
            type: 'boolean'
        },
        brand: {
            '$ref': '#/components/schemas/AdminDebugBrandDto'
        },
        profile: {
            '$ref': '#/components/schemas/AdminDebugProfileDto'
        },
        wallets: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminDebugWalletDto'
            }
        },
        missionCompletions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminDebugMissionCompletionDto'
            }
        },
        credentials: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminDebugCredentialDto'
            }
        },
        ticketBalance: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminDebugTicketBalanceDto'
            }
        },
        singlePurchases: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminDebugSinglePurchaseDto'
            }
        }
    },
    required: ['id', 'isBanned', 'isTestAccount', 'brand', 'profile', 'wallets', 'missionCompletions', 'credentials', 'ticketBalance', 'singlePurchases']
} as const;

export const $PaginationDto = {
    type: 'object',
    properties: {
        page: {
            type: 'number',
            example: 1
        },
        pageSize: {
            type: 'number',
            example: 20
        },
        totalPages: {
            type: 'number',
            example: 5
        }
    },
    required: ['page', 'pageSize', 'totalPages']
} as const;

export const $AdminDebugSearchUsersResponseDto = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminDebugUserListResponseDto'
            }
        },
        pagination: {
            '$ref': '#/components/schemas/PaginationDto'
        }
    },
    required: ['data', 'pagination']
} as const;

export const $AdminDebugUpdateUserFlagsDto = {
    type: 'object',
    properties: {
        isBanned: {
            type: 'boolean'
        },
        isTestAccount: {
            type: 'boolean'
        }
    },
    required: ['isBanned', 'isTestAccount']
} as const;

export const $AdminCmsPageResponseDto = {
    type: 'object',
    properties: {
        content: {
            type: 'string'
        }
    },
    required: ['content']
} as const;

export const $AdminUpdateCmsPageRequestDto = {
    type: 'object',
    properties: {
        content: {
            type: 'string'
        }
    },
    required: ['content']
} as const;

export const $AdminPagesLocaleResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        localeCode: {
            type: 'string'
        },
        languageCode: {
            type: 'string'
        },
        countryCode: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'localeCode', 'languageCode', 'countryCode', 'createdAt', 'updatedAt']
} as const;

export const $AdminPagesListResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminPagesLocaleResponseDto'
        },
        label: {
            type: 'string'
        },
        isEnabled: {
            type: 'boolean'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'locale', 'label', 'isEnabled', 'createdAt', 'updatedAt']
} as const;

export const $AdminPagesRouteResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        slug: {
            type: 'string'
        },
        access: {
            enum: ['guest', 'user'],
            type: 'string'
        },
        brand: {
            '$ref': '#/components/schemas/AdminPagesBrandResponseDto'
        },
        isEnabled: {
            type: 'boolean'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'slug', 'access', 'brand', 'isEnabled', 'createdAt', 'updatedAt']
} as const;

export const $AdminCmsImageListResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        images: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminCmsImageResponseDto'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'images', 'createdAt', 'updatedAt']
} as const;

export const $AdminPagesPageResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminPagesLocaleResponseDto'
        },
        routes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminPagesRouteResponseDto'
            }
        },
        label: {
            type: 'string'
        },
        isEnabled: {
            type: 'boolean'
        },
        metaTitle: {
            type: 'string'
        },
        metaDescription: {
            type: 'string'
        },
        metaRobotsIndex: {
            type: 'boolean'
        },
        metaRobotsFollow: {
            type: 'boolean'
        },
        metaOpenGraphTitle: {
            type: 'string'
        },
        metaOpenGraphDescription: {
            type: 'string'
        },
        metaOpenGraphSiteName: {
            type: 'string'
        },
        metaOpenGraphType: {
            enum: ['website', 'article'],
            type: 'string'
        },
        metaOpenGraphUrl: {
            type: 'string'
        },
        metaOpenGraphImageList: {
            '$ref': '#/components/schemas/AdminCmsImageListResponseDto'
        },
        metaTwitterCard: {
            enum: ['summary', 'summary_large_image', 'app'],
            type: 'string'
        },
        metaTwitterTitle: {
            type: 'string'
        },
        metaTwitterImageList: {
            '$ref': '#/components/schemas/AdminCmsImageListResponseDto'
        },
        metaTwitterDescription: {
            type: 'string'
        },
        contentBox: {
            type: 'string'
        },
        content: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'locale', 'routes', 'label', 'isEnabled', 'metaTitle', 'metaDescription', 'metaRobotsIndex', 'metaRobotsFollow', 'metaOpenGraphTitle', 'metaOpenGraphDescription', 'metaOpenGraphSiteName', 'metaOpenGraphType', 'metaOpenGraphUrl', 'metaOpenGraphImageList', 'metaTwitterCard', 'metaTwitterTitle', 'metaTwitterImageList', 'metaTwitterDescription', 'contentBox', 'content', 'createdAt', 'updatedAt']
} as const;

export const $AdminPagesCreatePageRequestDto = {
    type: 'object',
    properties: {
        localeId: {
            type: 'string'
        },
        label: {
            type: 'string',
            minLength: 1
        },
        isEnabled: {
            type: 'boolean'
        },
        metaTitle: {
            type: 'string'
        },
        metaDescription: {
            type: 'string'
        },
        metaRobotsIndex: {
            type: 'boolean'
        },
        metaRobotsFollow: {
            type: 'boolean'
        },
        metaOpenGraphTitle: {
            type: 'string'
        },
        metaOpenGraphDescription: {
            type: 'string'
        },
        metaOpenGraphSiteName: {
            type: 'string'
        },
        metaOpenGraphType: {
            type: 'string',
            enum: ['website', 'article']
        },
        metaOpenGraphUrl: {
            type: 'string'
        },
        metaTwitterCard: {
            type: 'string',
            enum: ['summary', 'summary_large_image', 'app']
        },
        metaTwitterTitle: {
            type: 'string'
        },
        metaTwitterDescription: {
            type: 'string'
        },
        contentBox: {
            type: 'string'
        },
        content: {
            type: 'string'
        }
    },
    required: ['localeId', 'label', 'isEnabled', 'metaTitle', 'metaDescription', 'metaRobotsIndex', 'metaRobotsFollow', 'metaOpenGraphTitle', 'metaOpenGraphDescription', 'metaOpenGraphSiteName', 'metaOpenGraphType', 'metaOpenGraphUrl', 'metaTwitterCard', 'metaTwitterTitle', 'metaTwitterDescription', 'contentBox', 'content']
} as const;

export const $AdminCmsImageListRequestDto = {
    type: 'object',
    properties: {
        images: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminCmsImageRequestDto'
            }
        }
    },
    required: ['images']
} as const;

export const $AdminPagesUpdatePageRequestDto = {
    type: 'object',
    properties: {
        localeId: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        isEnabled: {
            type: 'boolean'
        },
        metaTitle: {
            type: 'string'
        },
        metaDescription: {
            type: 'string'
        },
        metaRobotsIndex: {
            type: 'boolean'
        },
        metaRobotsFollow: {
            type: 'boolean'
        },
        metaOpenGraphTitle: {
            type: 'string'
        },
        metaOpenGraphDescription: {
            type: 'string'
        },
        metaOpenGraphSiteName: {
            type: 'string'
        },
        metaOpenGraphType: {
            type: 'string',
            enum: ['website', 'article']
        },
        metaOpenGraphUrl: {
            type: 'string'
        },
        metaOpenGraphImageList: {
            '$ref': '#/components/schemas/AdminCmsImageListRequestDto'
        },
        metaTwitterCard: {
            type: 'string',
            enum: ['summary', 'summary_large_image', 'app']
        },
        metaTwitterTitle: {
            type: 'string'
        },
        metaTwitterDescription: {
            type: 'string'
        },
        metaTwitterImageList: {
            '$ref': '#/components/schemas/AdminCmsImageListRequestDto'
        },
        contentBox: {
            type: 'string'
        },
        content: {
            type: 'string'
        }
    },
    required: ['localeId', 'label', 'isEnabled', 'metaTitle', 'metaDescription', 'metaRobotsIndex', 'metaRobotsFollow', 'metaOpenGraphTitle', 'metaOpenGraphDescription', 'metaOpenGraphSiteName', 'metaOpenGraphType', 'metaOpenGraphUrl', 'metaOpenGraphImageList', 'metaTwitterCard', 'metaTwitterTitle', 'metaTwitterDescription', 'metaTwitterImageList', 'contentBox', 'content']
} as const;

export const $AdminPagesCreateRouteRequestDto = {
    type: 'object',
    properties: {
        slug: {
            type: 'string'
        },
        access: {
            type: 'string',
            enum: ['guest', 'user']
        },
        brandId: {
            type: 'string'
        },
        isEnabled: {
            type: 'boolean'
        }
    },
    required: ['slug', 'access', 'brandId', 'isEnabled']
} as const;

export const $AdminPagesUpdateRouteRequestDto = {
    type: 'object',
    properties: {
        slug: {
            type: 'string'
        },
        access: {
            type: 'string',
            enum: ['guest', 'user']
        },
        brandId: {
            type: 'string'
        },
        isEnabled: {
            type: 'boolean'
        }
    },
    required: ['slug', 'access', 'brandId', 'isEnabled']
} as const;

export const $AdminComponentI18nLocaleResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        localeCode: {
            type: 'string'
        },
        languageCode: {
            type: 'string'
        },
        countryCode: {
            type: 'string'
        }
    },
    required: ['id', 'localeCode', 'languageCode', 'countryCode']
} as const;

export const $AdminComponentI18nBrandHostResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        hostname: {
            type: 'string'
        }
    },
    required: ['id', 'hostname']
} as const;

export const $AdminComponentI18nBrandResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        hosts: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminComponentI18nBrandHostResponseDto'
            }
        }
    },
    required: ['id', 'label', 'hosts']
} as const;

export const $AdminComponentI18nListResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        component: {
            type: 'string',
            enum: ['CountDown', 'CurrencySelector', 'DashboardHero', 'DashboardMissions', 'HeroJackpot', 'HeroJackpotLoginForm', 'HeroJackpotRegisterForm', 'HeroJackpotTicketPurchaseForm', 'Jackpots', 'JackpotMissionItem', 'JackpotMissionTickets', 'JackpotPurchaseTickets', 'JackpotTestimonials', 'JackpotWinners', 'JackpotWinnersV2', 'Leaderboard', 'OverlayPurchaseConfirm', 'OverlayPurchaseFailure', 'OverlayPurchaseSuccess', 'OverlayPurchaseTickets', 'PlatformStats', 'TutorialV2', 'UserMissionsClient', 'UserStats']
        },
        key: {
            type: 'string'
        },
        value: {
            type: 'string'
        },
        locale: {
            '$ref': '#/components/schemas/AdminComponentI18nLocaleResponseDto'
        },
        brand: {
            '$ref': '#/components/schemas/AdminComponentI18nBrandResponseDto'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'component', 'key', 'value', 'locale', 'brand', 'createdAt', 'updatedAt']
} as const;

export const $AdminComponentI18nResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        brand: {
            '$ref': '#/components/schemas/AdminComponentI18nBrandResponseDto'
        },
        namespace: {
            '$ref': '#/components/schemas/AdminNamespaceResponseDto'
        },
        locale: {
            '$ref': '#/components/schemas/AdminComponentI18nLocaleResponseDto'
        },
        component: {
            enum: ['CountDown', 'CurrencySelector', 'DashboardHero', 'DashboardMissions', 'HeroJackpot', 'HeroJackpotLoginForm', 'HeroJackpotRegisterForm', 'HeroJackpotTicketPurchaseForm', 'Jackpots', 'JackpotMissionItem', 'JackpotMissionTickets', 'JackpotPurchaseTickets', 'JackpotTestimonials', 'JackpotWinners', 'JackpotWinnersV2', 'Leaderboard', 'OverlayPurchaseConfirm', 'OverlayPurchaseFailure', 'OverlayPurchaseSuccess', 'OverlayPurchaseTickets', 'PlatformStats', 'TutorialV2', 'UserMissionsClient', 'UserStats'],
            type: 'string'
        },
        key: {
            type: 'string'
        },
        value: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'brand', 'namespace', 'locale', 'component', 'key', 'value', 'createdAt', 'updatedAt']
} as const;

export const $AdminNamespaceResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        ns: {
            type: 'string'
        },
        componentI18ns: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminComponentI18nResponseDto'
            }
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'ns', 'componentI18ns', 'createdAt', 'updatedAt']
} as const;

export const $AdminComponentI18nCreateComponentI18nRequestDto = {
    type: 'object',
    properties: {
        brandId: {
            type: 'string'
        },
        namespaceId: {
            type: 'string'
        },
        localeId: {
            type: 'string'
        },
        component: {
            type: 'string',
            enum: ['CountDown', 'CurrencySelector', 'DashboardHero', 'DashboardMissions', 'HeroJackpot', 'HeroJackpotLoginForm', 'HeroJackpotRegisterForm', 'HeroJackpotTicketPurchaseForm', 'Jackpots', 'JackpotMissionItem', 'JackpotMissionTickets', 'JackpotPurchaseTickets', 'JackpotTestimonials', 'JackpotWinners', 'JackpotWinnersV2', 'Leaderboard', 'OverlayPurchaseConfirm', 'OverlayPurchaseFailure', 'OverlayPurchaseSuccess', 'OverlayPurchaseTickets', 'PlatformStats', 'TutorialV2', 'UserMissionsClient', 'UserStats']
        },
        key: {
            type: 'string'
        },
        value: {
            type: 'string'
        }
    },
    required: ['brandId', 'namespaceId', 'localeId', 'component', 'key', 'value']
} as const;

export const $AdminComponentI18nUpdateComponentI18nRequestDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        brandId: {
            type: 'string'
        },
        namespaceId: {
            type: 'string'
        },
        localeId: {
            type: 'string'
        },
        component: {
            type: 'string',
            enum: ['CountDown', 'CurrencySelector', 'DashboardHero', 'DashboardMissions', 'HeroJackpot', 'HeroJackpotLoginForm', 'HeroJackpotRegisterForm', 'HeroJackpotTicketPurchaseForm', 'Jackpots', 'JackpotMissionItem', 'JackpotMissionTickets', 'JackpotPurchaseTickets', 'JackpotTestimonials', 'JackpotWinners', 'JackpotWinnersV2', 'Leaderboard', 'OverlayPurchaseConfirm', 'OverlayPurchaseFailure', 'OverlayPurchaseSuccess', 'OverlayPurchaseTickets', 'PlatformStats', 'TutorialV2', 'UserMissionsClient', 'UserStats']
        },
        key: {
            type: 'string'
        },
        value: {
            type: 'string'
        }
    },
    required: ['brandId', 'namespaceId', 'localeId', 'component', 'key', 'value']
} as const;

export const $AdminNamespaceListResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        ns: {
            type: 'string'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'ns', 'createdAt', 'updatedAt']
} as const;

export const $AdminNamespaceCreateNamespaceRequestDto = {
    type: 'object',
    properties: {
        ns: {
            type: 'string'
        }
    },
    required: ['ns']
} as const;

export const $AdminNamespaceUpdateNamespaceRequestDto = {
    type: 'object',
    properties: {
        ns: {
            type: 'string'
        },
        componentI18ns: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AdminComponentI18nUpdateComponentI18nRequestDto'
            }
        }
    },
    required: ['ns', 'componentI18ns']
} as const;

export const $AdminTestimonialResponseDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        quote: {
            type: 'string'
        },
        imageUrl: {
            type: 'string'
        },
        isEnabled: {
            type: 'boolean'
        },
        jackpot: {
            '$ref': '#/components/schemas/AdminJackpotResponseDto'
        },
        createdAt: {
            format: 'date-time',
            type: 'string'
        },
        updatedAt: {
            format: 'date-time',
            type: 'string'
        }
    },
    required: ['id', 'name', 'quote', 'imageUrl', 'isEnabled', 'jackpot', 'createdAt', 'updatedAt']
} as const;

export const $AdminTestimonialCreateRequestDto = {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        quote: {
            type: 'string'
        },
        imageUrl: {
            type: 'string'
        },
        isEnabled: {
            type: 'boolean'
        },
        jackpotId: {
            type: 'string'
        }
    },
    required: ['name', 'quote', 'imageUrl', 'isEnabled', 'jackpotId']
} as const;

export const $AdminTestimonialUpdateRequestDto = {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        quote: {
            type: 'string'
        },
        imageUrl: {
            type: 'string'
        },
        isEnabled: {
            type: 'boolean'
        },
        jackpotId: {
            type: 'string'
        }
    },
    required: ['name', 'quote', 'imageUrl', 'isEnabled', 'jackpotId']
} as const;

export const $DailyRegistrationsDto = {
    type: 'object',
    properties: {
        date: {
            format: 'date-time',
            type: 'string'
        },
        count: {
            type: 'number'
        }
    },
    required: ['date', 'count']
} as const;

export const $DailyActiveUsersDto = {
    type: 'object',
    properties: {
        date: {
            format: 'date-time',
            type: 'string'
        },
        count: {
            type: 'number'
        }
    },
    required: ['date', 'count']
} as const;

export const $DailyMissionCompletionsDto = {
    type: 'object',
    properties: {
        date: {
            format: 'date-time',
            type: 'string'
        },
        count: {
            type: 'number'
        },
        missionType: {
            type: 'string'
        }
    },
    required: ['date', 'count', 'missionType']
} as const;

export const $MissionCompletionsPerUserDto = {
    type: 'object',
    properties: {
        identityId: {
            type: 'string'
        },
        firstName: {
            type: 'string'
        },
        lastName: {
            type: 'string'
        },
        nickName: {
            type: 'string'
        },
        email: {
            type: 'string'
        },
        count: {
            type: 'number'
        }
    },
    required: ['identityId', 'firstName', 'lastName', 'nickName', 'email', 'count']
} as const;

export const $DailyTicketRevenueDto = {
    type: 'object',
    properties: {
        date: {
            format: 'date-time',
            type: 'string'
        },
        ticketId: {
            type: 'string'
        },
        ticketName: {
            type: 'string'
        },
        revenue: {
            type: 'string'
        },
        currency: {
            type: 'string'
        }
    },
    required: ['date', 'ticketId', 'ticketName', 'revenue', 'currency']
} as const;

export const $DailyTicketPurchasesDto = {
    type: 'object',
    properties: {
        date: {
            format: 'date-time',
            type: 'string'
        },
        ticketId: {
            type: 'string'
        },
        ticketName: {
            type: 'string'
        },
        count: {
            type: 'number'
        },
        numberOfSales: {
            type: 'number'
        }
    },
    required: ['date', 'ticketId', 'ticketName', 'count', 'numberOfSales']
} as const;

export const $Map = {
    type: 'object',
    properties: {}
} as const;

export const $BhgReverseApiGameLaunchRequestDto = {
    type: 'object',
    properties: {
        account: {
            type: 'string'
        },
        game: {
            type: 'string'
        },
        brand: {
            type: 'string'
        },
        token: {
            type: 'string'
        },
        language: {
            type: 'string'
        },
        currency: {
            type: 'string'
        },
        platform: {
            type: 'string',
            enum: ['DESKTOP', 'MOBILE']
        },
        isDemo: {
            type: 'boolean'
        },
        closeUrl: {
            type: 'string'
        },
        lobbyUrl: {
            type: 'string'
        },
        cashierUrl: {
            type: 'string'
        },
        extraData: {
            '$ref': '#/components/schemas/Map'
        }
    },
    required: ['account', 'game', 'brand', 'token', 'language', 'currency', 'platform', 'isDemo', 'extraData']
} as const;

export const $BhgReverseApiErrorDto = {
    type: 'object',
    properties: {
        code: {
            type: 'string',
            enum: ['DUPLICATE_TRANSACTION', 'BET_DOES_NOT_EXIST', 'USER_DOES_NOT_EXIST', 'INVALID_REQUEST_SIGNATURE', 'INVALID_CURRENCY', 'NOT_ENOUGH_MONEY', 'INVALID_GAME', 'INVALID_SESSION', 'ALREADY_CLOSED_ROUND', 'BLOCKED_PLAYER', 'GENERAL_ERROR']
        },
        description: {
            type: 'string'
        }
    },
    required: ['code', 'description']
} as const;

export const $BhgReverseApiGameLaunchUrlResponseDto = {
    type: 'object',
    properties: {
        url: {
            type: 'string'
        }
    },
    required: ['url']
} as const;

export const $BhgReverseApiGameLaunchResponseDto = {
    type: 'object',
    properties: {
        hasErrors: {
            type: 'boolean',
            default: false
        },
        errors: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BhgReverseApiErrorDto'
            }
        },
        body: {
            '$ref': '#/components/schemas/BhgReverseApiGameLaunchUrlResponseDto'
        }
    },
    required: ['hasErrors', 'errors', 'body']
} as const;

export const $BhgReverseApiGameListRequestDto = {
    type: 'object',
    properties: {
        brand: {
            type: 'string'
        }
    },
    required: ['brand']
} as const;

export const $BhgReverseApiGameListGameResponseDto = {
    type: 'object',
    properties: {
        subProvider: {
            type: 'string',
            default: null
        },
        id: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        category: {
            type: 'string',
            enum: ['TABLE_CARD', 'BACCARAT', 'LIVE_POKER', 'CRASH', 'OTHERS_LIVE', 'BINGO', 'ARCADE', 'OTHERS_TABLE', 'SLOTS', 'SCRATCH', 'JACKPOTS', 'DEFAULT', 'OTHERS', 'LIVE_DRAGON_TIGER', 'DICE', 'LOTTERY', 'MINIGAMES', 'LIVE_BLACKJACK', 'PLAYER_PROPS', 'DRAGON_TIGER', 'ROULETTE', 'VIDEO_POKER', 'LIVE_BACCARAT', 'BLACKJACK', 'LIVE_DICE', 'LIVE_ROULETTE', 'GAME_SHOW', 'VIRTUAL']
        },
        enabled: {
            type: 'boolean'
        },
        blockedCountries: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        supportedLanguages: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        supportedCurrencies: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        supportedPlatforms: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['DESKTOP', 'MOBILE']
            }
        },
        features: {
            default: null,
            type: 'array',
            items: {
                type: 'string'
            }
        },
        backgroundUrl: {
            type: 'string',
            default: null
        },
        thumbnailUrl: {
            type: 'string',
            default: null
        },
        rtp: {
            type: 'string'
        },
        extraData: {
            type: 'object',
            default: null
        }
    },
    required: ['id', 'name', 'category', 'enabled', 'blockedCountries', 'supportedCurrencies', 'supportedPlatforms', 'rtp']
} as const;

export const $BhgReverseApiGameListResponseDto = {
    type: 'object',
    properties: {
        hasErrors: {
            type: 'boolean',
            default: false
        },
        errors: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BhgReverseApiErrorDto'
            }
        },
        body: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BhgReverseApiGameListGameResponseDto'
            }
        }
    },
    required: ['hasErrors', 'errors', 'body']
} as const;

export const $BhgReverseApiRoundHistoryRequestDto = {
    type: 'object',
    properties: {
        round: {
            type: 'string'
        },
        brand: {
            type: 'string'
        },
        game: {
            type: 'string'
        }
    },
    required: ['round', 'brand', 'game']
} as const;

export const $BhgReverseApiRoundHistoryBodyResponseDto = {
    type: 'object',
    properties: {
        url: {
            type: 'string'
        }
    },
    required: ['url']
} as const;

export const $BhgReverseApiRoundHistoryResponseDto = {
    type: 'object',
    properties: {
        hasErrors: {
            type: 'boolean',
            default: false
        },
        errors: {
            default: [],
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BhgReverseApiErrorDto'
            }
        },
        body: {
            '$ref': '#/components/schemas/BhgReverseApiRoundHistoryBodyResponseDto'
        }
    },
    required: ['hasErrors', 'errors', 'body']
} as const;